/* Temalli® v2 — interações das seções Temalli (tema Shopify).
   Compra: adiciona ao carrinho via /cart/add.js e abre a gaveta de carrinho; o checkout é o nativo da Shopify. */
(function(){
  // revelar ao rolar. Fica no começo: se outra parte do script falhar, o conteúdo continua aparecendo
  var io = null, ioPir = null;
  if('IntersectionObserver' in window){
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('on'); io.unobserve(en.target); } });
    },{threshold:.12});
    // a pirâmide só se monta quando está bem visível (não na beirada da tela)
    ioPir = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('on'); ioPir.unobserve(en.target); } });
    },{threshold:.55});
  }
  function revela(raiz){
    raiz.querySelectorAll('.reveal:not(.on)').forEach(function(el){
      if(io){ (el.classList.contains('piramide') ? ioPir : io).observe(el); } else { el.classList.add('on'); }
    });
  }
  revela(document);
  // editor da Shopify: a seção editada volta recarregada; revela de novo o que estiver nela
  document.addEventListener('shopify:section:load', function(e){ revela(e.target); });

  // cada parte da página roda isolada: um erro numa delas não derruba as outras
  function falhou(parte, erro){ if(window.console){ console.error('[Temalli] falha em ' + parte, erro); } }

  // Campanha com data (Black November): a faixa, o selo e o destaque só aparecem no período, no dia de
  // Brasília (data-campanha-inicio/fim, AAAA-MM-DD); data-campanha-fora é o que aparece fora dele (a faixa de sempre).
  // No tema o Liquid já decide; aqui confere de novo, porque a página pode vir de cache.
  try {
    var hojeBR = new Date().toLocaleDateString('en-CA', {timeZone: 'America/Sao_Paulo'});
    document.querySelectorAll('[data-campanha-fim]').forEach(function(el){
      var dentro = hojeBR >= (el.getAttribute('data-campanha-inicio') || '0000-00-00') && hojeBR <= el.getAttribute('data-campanha-fim');
      el.hidden = el.hasAttribute('data-campanha-fora') ? dentro : !dentro;
    });
  } catch(erro){ falhou('campanha', erro); }

  function comprar(itens, botao){
    if(!itens || !itens.length){ return; }
    var texto = botao ? botao.textContent : '', t0 = Date.now();
    if(botao){ botao.disabled = true; graosVoam(botao); graoGirando(botao, 'Adicionando…'); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: itens})
    }).then(function(r){
      if(!r.ok){ throw r; }
      // deixa os grãos terminarem de voar e abre a gaveta de carrinho (sem gaveta: vai para /cart)
      setTimeout(function(){
        if(botao){ botao.disabled = false; botao.textContent = texto; }
        if(!window.TML_ABRIR_CARRINHO || !window.TML_ABRIR_CARRINHO()){ window.location.href = '/cart'; }
      }, Math.max(0, 650 - (Date.now() - t0)));
    }).catch(function(){
      if(botao){ botao.disabled = false; botao.textContent = 'Não foi possível adicionar. Tente de novo'; setTimeout(function(){ botao.textContent = texto; }, 3500); }
    });
  }
  window.TML_COMPRAR = comprar;

  // ===== microanimações do café =====
  var REDUZ = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // grãos pulando a partir do botão de compra
  function graosVoam(botao){
    if(REDUZ || !botao){ return; }
    var r = botao.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    for(var i = 0; i < 10; i++){
      var g = document.createElement('span');
      var ang = Math.PI * 2 * i / 10 + Math.random() * 0.5, dist = 60 + Math.random() * 55;
      g.className = 'grao-voa';
      g.style.left = cx + 'px'; g.style.top = cy + 'px';
      g.style.setProperty('--dx', Math.round(Math.cos(ang) * dist) + 'px');
      g.style.setProperty('--dy', Math.round(Math.sin(ang) * dist - 45) + 'px');
      g.style.setProperty('--r', Math.round(Math.random() * 540 - 270) + 'deg');
      document.body.appendChild(g);
      setTimeout(g.remove.bind(g), 950);
    }
  }
  function graoGirando(botao, texto){ botao.innerHTML = '<span class="grao-gira" aria-hidden="true"></span>' + texto; }
  // 4º pacote (grátis) cai no kit
  function pacoteCai(box){
    if(REDUZ){ return; }
    var p = box.querySelector('.pac.gratis'); if(!p){ return; }
    p.classList.remove('cai'); void p.offsetWidth; p.classList.add('cai');
  }
  // números contando quando aparecem
  if(!REDUZ && 'IntersectionObserver' in window){
    var padrao = /^(\D*)(\d+(?:,\d+)?)(.*)$/;
    var obsNum = new IntersectionObserver(function(es){
      es.forEach(function(en){
        if(!en.isIntersecting){ return; }
        obsNum.unobserve(en.target);
        var el = en.target, m = el.dataset.final.match(padrao);
        var alvo = parseFloat(m[2].replace(',', '.')), casas = (m[2].split(',')[1] || '').length, t0 = null;
        function passo(t){
          if(!t0){ t0 = t; }
          var p = Math.min(1, (t - t0) / 1300), v = alvo * (1 - Math.pow(1 - p, 3));
          el.textContent = p < 1 ? m[1] + v.toFixed(casas).replace('.', ',') + m[3] : el.dataset.final;
          if(p < 1){ requestAnimationFrame(passo); }
        }
        requestAnimationFrame(passo);
      });
    }, {threshold: 0.6});
    document.querySelectorAll('.selos li b, .dep-nota b, .lancamento b').forEach(function(el){
      if(el.children.length || !padrao.test(el.textContent.trim())){ return; }
      el.dataset.final = el.textContent.trim();
      obsNum.observe(el);
    });
  }
  // o pacote grátis cai a primeira vez que a caixa de compra aparece
  if('IntersectionObserver' in window){
    var obsKit = new IntersectionObserver(function(es){
      es.forEach(function(en){ if(en.isIntersecting){ obsKit.unobserve(en.target); pacoteCai(en.target); } });
    }, {threshold: 0.5});
    document.querySelectorAll('.opcao.kit').forEach(function(k){ obsKit.observe(k); });
  }
  var brl = function(v){ return v.toLocaleString('pt-BR',{style:'currency',currency:'BRL'}); };

  // menu mobile
  var nav = document.querySelector('.nav');
  var toggle = document.querySelector('.menu-toggle');
  if(nav && toggle){
    toggle.addEventListener('click', function(){
      var aberto = nav.classList.toggle('aberto');
      toggle.setAttribute('aria-expanded', aberto);
    });
  }

  // cabeçalho fixo só ao rolar para cima: some ao descer (mais espaço para ler) e volta no primeiro movimento para cima.
  // No topo da página e com o menu aberto ele fica sempre visível. Tema: o bloco fixo é .tml-secao-header; protótipo: header.site
  var cab = document.querySelector('.tml-secao-header') || document.querySelector('header.site');
  if(cab){
    var ultimoY = window.scrollY, pendenteCab = false;
    window.addEventListener('scroll', function(){
      if(pendenteCab){ return; }
      pendenteCab = true;
      requestAnimationFrame(function(){
        var y = window.scrollY, delta = y - ultimoY, menuAberto = document.querySelector('.nav.aberto');
        if(y < cab.offsetHeight + 40 || menuAberto){ cab.classList.remove('cab-oculto'); }
        else if(delta > 8){ cab.classList.add('cab-oculto'); }
        else if(delta < -8){ cab.classList.remove('cab-oculto'); }
        if(Math.abs(delta) > 8){ ultimoY = y; }
        pendenteCab = false;
      });
    }, {passive: true});
  }

  // caixa de compra: quantidade (1 ou kit 4) + formato (grão/moído) -> link de carrinho
  // Com o cupom de um parceiro confirmado no carrinho (bloco dos parceiros, mais abaixo), os preços
  // passam a mostrar o valor com o cupom: TML_CUPOM_NA_CAIXA(codigo, pct)
  var cupomCaixa = null, caixasCupom = [];
  window.TML_CUPOM_NA_CAIXA = function(codigo, pct){ cupomCaixa = {codigo: codigo, pct: pct}; caixasCupom.forEach(function(f){ f(); }); };
  var comCupom = function(v){ return cupomCaixa ? Math.round(v * (100 - cupomCaixa.pct)) / 100 : v; };
  try {
    document.querySelectorAll('[data-buybox]').forEach(function(box){
      var preco = parseFloat(box.dataset.preco);
      var cta = box.querySelector('[data-cta]');
      var total = box.querySelector('[data-total]');
      var barPreco = document.querySelector('[data-buybar-preco]');
      var barInfo = document.querySelector('[data-buybar-info]');
      var barCta = document.querySelector('[data-buybar-cta]');
      var itens = [];

      function atualiza(){
        var qtd = parseInt(box.querySelector('input[name="qtd"]:checked').value, 10);
        var formato = box.querySelector('input[name="formato"]:checked').value;
        var variante = box.dataset[formato];
        if(qtd === 4 && box.dataset.qtdAnterior && box.dataset.qtdAnterior !== '4'){ pacoteCai(box); }
        box.dataset.qtdAnterior = qtd;
        var pagas = qtd === 4 ? 3 : qtd;               // Pague 3 Leve 4
        var valor = comCupom(preco * pagas);
        itens = /^\d+$/.test(variante) ? [{id: +variante, quantity: qtd}] : [];
        total.textContent = brl(valor);
        cta.disabled = !itens.length;
        var eco = box.querySelector('[data-economia]');
        if(eco){ eco.textContent = qtd === 4 || cupomCaixa ? 'Você economiza ' + brl(Math.round((preco * qtd - valor) * 100) / 100) : ''; }
        cta.textContent = qtd === 4 ? 'Comprar 4 pacotes, pague 3' : 'Comprar ' + qtd + (qtd > 1 ? ' pacotes' : ' pacote');
        if(barPreco){ barPreco.textContent = brl(valor); }
        if(barInfo){ barInfo.textContent = (qtd === 4 ? 'Pague 3, leve 4' : qtd + (qtd > 1 ? ' unidades' : ' unidade')) + (formato === 'moido' ? ' • moído' : ' • em grãos'); }
      }
      // preços com o cupom: cada opção mostra o cheio riscado e o valor com o cupom
      caixasCupom.push(function(){
        box.querySelectorAll('input[name="qtd"]').forEach(function(inp){
          var q = +inp.value, cheio = preco * (q === 4 ? 3 : q), fim = comCupom(cheio);
          var op = inp.closest('.opcao'), val = op && op.querySelector('.valor'), b = val && val.querySelector('b');
          if(!b){ return; }
          b.textContent = brl(fim);
          if(q === 4){
            var em = val.querySelector('em'); if(em){ em.textContent = Math.round((1 - fim / (preco * 4)) * 100) + '% OFF'; }
            var sm = op.querySelector('.opcao-txt > small'); if(sm){ sm.textContent = 'Só ' + brl(Math.round(fim * 25) / 100) + ' por pacote'; }
            var se = op.querySelector('.selo-eco'); if(se){ se.textContent = 'Economize ' + brl(Math.round((preco * 4 - fim) * 100) / 100); }
          } else if(!val.querySelector('s')){ var s = document.createElement('s'); s.textContent = brl(cheio); val.insertBefore(s, b); }
        });
        if(!box.querySelector('.cupom-caixa')){
          var av = document.createElement('p'); av.className = 'cupom-caixa';
          av.textContent = 'Cupom ' + cupomCaixa.codigo + ' aplicado: ' + String(cupomCaixa.pct).replace('.', ',') + '% de desconto no pedido';
          box.insertBefore(av, box.firstChild);
        }
        var rapido = document.querySelector('.preco-rapido');
        if(rapido){ rapido.innerHTML = '<b>' + brl(comCupom(preco)) + '</b> • no kit de 4, ' + brl(Math.round(comCupom(preco * 3) * 25) / 100) + ' por pacote'; }
        atualiza();
      });
      box.addEventListener('change', atualiza);
      cta.addEventListener('click', function(e){ e.preventDefault(); comprar(itens, cta); });
      if(barCta){ barCta.addEventListener('click', function(e){ e.preventDefault(); comprar(itens, barCta); }); }
      atualiza();
    });
  } catch(erro){ falhou('caixa de compra', erro); }

  // galeria: carrossel com miniaturas numa linha, setas, arrastar no celular e contador
  try {
    document.querySelectorAll('[data-galeria]').forEach(function(g){
      var principal = g.querySelector('.principal img');
      var area = g.querySelector('.principal');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.thumbs button'));
      var cont = g.querySelector('.gal-cont');
      var atual = 0;
      if(!principal || thumbs.length < 2){ return; }
      function mostra(i){
        atual = (i + thumbs.length) % thumbs.length;
        var b = thumbs[atual];
        principal.removeAttribute('srcset'); principal.removeAttribute('sizes');
        principal.src = b.dataset.src;
        principal.alt = b.querySelector('img').alt;
        thumbs.forEach(function(x, j){ x.setAttribute('aria-pressed', j === atual ? 'true' : 'false'); });
        var trilho = b.parentNode;
        // centraliza a miniatura ativa: na horizontal (computador) ou na vertical (celular, coluna à esquerda)
        trilho.scrollTo({left: b.offsetLeft - trilho.clientWidth / 2 + b.clientWidth / 2, top: b.offsetTop - trilho.clientHeight / 2 + b.clientHeight / 2, behavior: 'smooth'});
        if(cont){ cont.textContent = (atual + 1) + ' / ' + thumbs.length; }
      }
      thumbs.forEach(function(b, i){ b.addEventListener('click', function(){ mostra(i); }); });
      var ant = g.querySelector('[data-gal-ant]'), prox = g.querySelector('[data-gal-prox]');
      if(ant){ ant.addEventListener('click', function(){ mostra(atual - 1); }); }
      if(prox){ prox.addEventListener('click', function(){ mostra(atual + 1); }); }
      var x0 = null;
      area.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive: true});
      area.addEventListener('touchend', function(e){
        if(x0 === null){ return; }
        var dx = e.changedTouches[0].clientX - x0;
        if(Math.abs(dx) > 40){ mostra(atual + (dx < 0 ? 1 : -1)); }
        x0 = null;
      });
    });
  } catch(erro){ falhou('galeria', erro); }

  // barra fixa mobile: aparece sempre que o botão de compra principal não está na tela (acima ou abaixo)
  try {
    var buybar = document.querySelector('.buybar');
    var alvo = document.querySelector('[data-buybox] [data-cta]');
    if(buybar && alvo && 'IntersectionObserver' in window){
      document.body.classList.add('tem-buybar');
      new IntersectionObserver(function(e){
        buybar.classList.toggle('on', !e[0].isIntersecting);
      }).observe(alvo);
    }
  } catch(erro){ falhou('barra fixa', erro); }

  // depoimentos: mostrar mais
  try {
    document.querySelectorAll('[data-dep-mais]').forEach(function(b){
      b.addEventListener('click', function(){
        var dep = b.closest('.dep');
        var aberto = dep.classList.toggle('aberto');
        b.textContent = aberto ? 'Mostrar menos' : b.dataset.label;
        b.setAttribute('aria-expanded', aberto);
      });
      b.dataset.label = b.textContent;
    });
  } catch(erro){ falhou('depoimentos', erro); }

  // kit degustação: 1 Clássico + 1 Arara, cada um em grão ou moído -> link de carrinho com os dois
  try {
    document.querySelectorAll('[data-degustacao]').forEach(function(box){
      var cta = box.querySelector('[data-deg-cta]');
      function atualiza(){
        var ids = Array.prototype.map.call(box.querySelectorAll('.deg-itens li'), function(li){
          return li.dataset[li.querySelector('[data-formato][aria-pressed="true"]').dataset.formato];
        });
        var ok = ids.every(function(id){ return /^\d+$/.test(id); });
        box.itens = ok ? ids.map(function(id){ return {id: +id, quantity: 1}; }) : [];
        cta.disabled = !ok;
      }
      cta.addEventListener('click', function(e){ e.preventDefault(); comprar(box.itens, cta); });
      box.addEventListener('click', function(e){
        var b = e.target.closest('[data-formato]'); if(!b) return;
        b.parentNode.querySelectorAll('[data-formato]').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        atualiza();
      });
      atualiza();
    });
  } catch(erro){ falhou('kit degustação', erro); }

  // Assinatura pelo site: chamadas ao Temalli CRM pelo App Proxy da Shopify (/apps/temalli)
  var ASSINATURA = {
    config: function(){ return fetch('/apps/temalli/assinatura/config', {headers: {'Accept': 'application/json'}}).then(function(r){ if(!r.ok){ throw r; } return r.json(); }); },
    criar: function(d){ return fetch('/apps/temalli/assinatura/criar', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(d)}).then(function(r){ return r.json(); }); }
  };
  // assinatura: monta o pedido. Com a assinatura pelo site ligada no CRM, paga com cartão (Asaas);
  // desligada (ou se o CRM não responder), abre o WhatsApp com a mensagem pronta
  try {
    var CICLO_DO_RADIO = { 'Mensal': 'MONTHLY', 'Bimestral': 'BIMONTHLY', 'Trimestral': 'QUARTERLY' };
    document.querySelectorAll('[data-assinatura]').forEach(function(m){
      var cafes = m.querySelectorAll('.m-cafe');
      var cta = m.querySelector('[data-assinar]');
      var aviso = m.querySelector('[data-aviso]');
      var online = m.querySelector('[data-online]');
      var pagar = m.querySelector('[data-pagar]');
      var regras = null; // config do CRM quando a assinatura pelo site está ligada
      var busca = new URLSearchParams(location.search);
      var troca = busca.get('troca'), tokenTroca = busca.get('t');
      // Cada café tem uma linha por formato (grão, moído), cada uma com a sua quantidade
      function qtdDe(linha){ return parseInt(linha.querySelector('output').textContent, 10) || 0; }
      function estado(){
        var itens = [];
        cafes.forEach(function(c){
          c.querySelectorAll('.m-linha').forEach(function(l){
            var q = qtdDe(l);
            if(q > 0){ itens.push({ nome: c.dataset.cafe, preco: parseFloat(c.dataset.preco), qtd: q, formato: l.dataset.formato, variante: l.dataset.variante }); }
          });
        });
        return itens;
      }
      function freqAtual(){ return m.querySelector('input[name="freq"]:checked'); }
      // Desconto do CRM: fixo (regras.desconto) ou progressivo pela quantidade de pacotes (regras.faixas)
      function faixaPara(qtd){ var f = null; (regras && regras.faixas || []).forEach(function(x){ if(qtd >= x.minimo){ f = x; } }); return f; }
      function proximaPara(qtd){ var f = null; (regras && regras.faixas || []).forEach(function(x){ if(!f && x.minimo > qtd){ f = x; } }); return f; }
      // Cupom do parceiro (cookies gravados pela página do parceiro): soma com o desconto de assinante,
      // sobre o que sobra dele (o CRM confere e recalcula ao criar a assinatura)
      function cupomParceiro(){
        if(!regras){ return null; }
        var ck = function(n){ var x = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return x ? decodeURIComponent(x[1]) : ''; };
        var apelido = ck('tml_parceiro'), codigo = ck('tml_cupom'), pct = parseFloat(ck('tml_cupom_pct'));
        return /^[a-z0-9-]{2,30}$/.test(apelido) && /^[A-Z0-9_-]{3,30}$/.test(codigo) && pct > 0 ? { apelido: apelido, codigo: codigo, pct: pct } : null;
      }
      function conta(itens){
        var sub = itens.reduce(function(s, c){ return s + c.preco * c.qtd; }, 0);
        var qtd = itens.reduce(function(s, c){ return s + c.qtd; }, 0);
        var faixa = faixaPara(qtd);
        var d = faixa ? { tipo: 'percentual', valor: faixa.percentual } : (regras && regras.desconto), desc = 0;
        if(d){ desc = d.tipo === 'percentual' ? sub * Math.min(d.valor, 100) / 100 : d.valor; desc = Math.round(Math.min(desc, sub) * 100) / 100; }
        var frete = regras ? regras.frete.valor : 0;
        var cp = cupomParceiro(), descCupom = cp ? Math.round((sub - desc) * cp.pct) / 100 : 0;
        return { sub: sub, desc: desc, pct: d && d.tipo === 'percentual' ? d.valor : null, qtd: qtd, frete: frete, cupom: cp, descCupom: descCupom, total: Math.round((sub - desc - descCupom + frete) * 100) / 100 };
      }
      function atualiza(){
        var itens = estado();
        var freq = freqAtual().value;
        var c = conta(itens);
        m.querySelector('[data-resumo-itens]').innerHTML = itens.length
          ? itens.map(function(c){ return '<li><b>' + c.qtd + '×</b> ' + c.nome + ' <span>(' + c.formato + ')</span></li>'; }).join('')
          : '<li class="vazio">Nenhum café escolhido</li>';
        m.querySelector('[data-resumo-freq]').textContent = freq;
        m.querySelector('[data-resumo-total]').textContent = brl(c.sub);
        if(regras){
          var linhaDesc = m.querySelector('[data-resumo-desconto]');
          linhaDesc.hidden = !c.desc;
          linhaDesc.querySelector('dt').textContent = (regras.desconto ? regras.desconto.motivo : (regras.descontoNome || 'Assinante')) + (c.pct ? ' · ' + String(c.pct).replace('.', ',') + '%' : '');
          // Progressivo: mostra quanto falta para a próxima faixa
          var avisoFaixa = m.querySelector('[data-proxima]'), prox = proximaPara(c.qtd);
          if(avisoFaixa){
            var falta = prox ? prox.minimo - c.qtd : 0;
            avisoFaixa.hidden = !prox || !c.qtd;
            if(prox){ avisoFaixa.textContent = 'Adicione mais ' + falta + (falta === 1 ? ' pacote' : ' pacotes') + ' e o desconto sobe para ' + String(prox.percentual).replace('.', ',') + '%.'; }
          }
          linhaDesc.querySelector('dd').textContent = '−' + brl(c.desc);
          var linhaCupom = m.querySelector('[data-resumo-cupom]');
          if(linhaCupom){
            linhaCupom.hidden = !(c.cupom && c.descCupom);
            if(c.cupom){ linhaCupom.querySelector('dt').textContent = 'Cupom ' + c.cupom.codigo + ' · ' + String(c.cupom.pct).replace('.', ',') + '%'; linhaCupom.querySelector('dd').textContent = '−' + brl(c.descCupom); }
          }
          m.querySelector('[data-resumo-frete]').textContent = c.frete ? regras.frete.nome + ' · ' + brl(c.frete) : 'Grátis';
          m.querySelector('[data-resumo-valor]').textContent = brl(c.total);
        }
        cafes.forEach(function(c){ c.classList.toggle('ativo', Array.prototype.some.call(c.querySelectorAll('.m-linha'), function(l){ return qtdDe(l) > 0; })); });
        var msg = 'Olá! Quero fazer a assinatura Temalli.\n\nFrequência: ' + freq + '\nCafés em cada entrega:\n' +
          itens.map(function(c){ return '- ' + c.qtd + 'x ' + c.nome + ' (' + c.formato + ')'; }).join('\n') +
          '\n\nPode me passar os próximos passos?';
        cta.href = 'https://wa.me/' + m.dataset.whats + '?text=' + encodeURIComponent(msg);
        cta.setAttribute('aria-disabled', itens.length ? 'false' : 'true');
        aviso.hidden = true;
      }
      function mostrarAviso(t){ aviso.textContent = t; aviso.hidden = false; }
      m.addEventListener('click', function(e){
        var b = e.target.closest('button'); if(!b || !m.contains(b) || b === pagar) return;
        var linha = b.closest('.m-linha'); if(!linha) return;
        if(b.hasAttribute('data-mais') || b.hasAttribute('data-menos')){
          var o = linha.querySelector('output');
          o.textContent = Math.max(0, Math.min(10, qtdDe(linha) + (b.hasAttribute('data-mais') ? 1 : -1)));
        }
        atualiza();
      });
      m.addEventListener('change', atualiza);
      cta.addEventListener('click', function(e){
        if(cta.getAttribute('aria-disabled') === 'true'){ e.preventDefault(); mostrarAviso('Escolha pelo menos um café.'); }
      });

      // topo da página: o desconto de assinante com os valores do CRM ("5% de desconto em toda entrega, 15% com 3 pacotes e ...")
      function textoDescontoAssinante(r){
        var d = r.desconto;
        if(d && d.valor){ return '<b>' + (d.tipo === 'percentual' ? d.valor + '%' : brl(d.valor)) + ' de desconto</b> em toda entrega'; }
        var fx = [];
        (r.faixas || []).slice().sort(function(a, b){ return a.minimo - b.minimo; }).forEach(function(f){
          if(f.percentual > 0 && (!fx.length || fx[fx.length - 1].percentual !== f.percentual)){ fx.push(f); }
        });
        if(!fx.length){ return ''; }
        var partes = fx.map(function(f, i){
          if(f.minimo <= 1){ return '<b>' + f.percentual + '% de desconto</b> em toda entrega'; }
          return f.percentual + '% com ' + f.minimo + ' pacotes' + (i === fx.length - 1 ? ' ou mais' : '');
        });
        var t = partes.length > 1 ? partes.slice(0, -1).join(', ') + ' e ' + partes[partes.length - 1] : partes[0];
        return fx[0].minimo <= 1 ? t : 'Desconto de assinante: ' + t;
      }
      // Assinatura pelo site: o CRM diz se está ligada e com que desconto, frete e frequências
      ASSINATURA.config().then(function(r){
        if(!r || !r.ativo || !online){ return; }
        regras = r;
        m.classList.add('m-online');
        document.documentElement.classList.add('tml-ass-online');
        var linhaDesc = document.querySelector('[data-ass-desconto]'), textoDesc = textoDescontoAssinante(r);
        if(linhaDesc && textoDesc){ linhaDesc.querySelector('span').innerHTML = textoDesc; linhaDesc.hidden = false; }
        online.hidden = false;
        var permitidos = (r.ciclos || []).map(function(c){ return c.valor; });
        m.querySelectorAll('input[name="freq"]').forEach(function(i){
          var ok = permitidos.indexOf(CICLO_DO_RADIO[i.value]) > -1;
          i.closest('.opcao').hidden = !ok;
          if(!ok && i.checked){ i.checked = false; }
        });
        if(!freqAtual()){ var primeiro = m.querySelector('.opcao:not([hidden]) input[name="freq"]'); if(primeiro){ primeiro.checked = true; } }
        if(troca && tokenTroca){ var t = m.querySelector('[data-troca]'); if(t){ t.hidden = false; } }
        atualiza();
      }).catch(function(){ /* sem CRM: fica o WhatsApp */ });

      if(pagar){
        pagar.addEventListener('click', function(){
          var itens = estado();
          if(!itens.length){ mostrarAviso('Escolha pelo menos um café.'); return; }
          var nome = online.querySelector('[name="nome"]').value.trim();
          var whatsapp = online.querySelector('[name="whatsapp"]').value.trim();
          var email = online.querySelector('[name="email"]').value.trim();
          if(nome.length < 2){ mostrarAviso('Informe o seu nome.'); return; }
          if(whatsapp.replace(/\D/g, '').length < 10){ mostrarAviso('Informe o WhatsApp com DDD.'); return; }
          var texto = pagar.textContent;
          pagar.disabled = true; pagar.textContent = 'Abrindo o pagamento…';
          ASSINATURA.criar({
            nome: nome, whatsapp: whatsapp, email: email,
            ciclo: CICLO_DO_RADIO[freqAtual().value],
            itens: itens.map(function(c){ return { varianteId: c.variante, quantidade: c.qtd }; }),
            troca: troca, token: tokenTroca,
            parceiro: (cupomParceiro() || {}).apelido
          }).then(function(r){
            if(r && r.ok && r.url){ location.href = r.url; return; }
            mostrarAviso((r && r.erro) || 'Não foi possível abrir o pagamento. Tente de novo ou fale com a gente no WhatsApp.');
            pagar.disabled = false; pagar.textContent = texto;
          }).catch(function(){
            mostrarAviso('Não foi possível abrir o pagamento. Tente de novo ou fale com a gente no WhatsApp.');
            pagar.disabled = false; pagar.textContent = texto;
          });
        });
      }
      atualiza();
    });
  } catch(erro){ falhou('assinatura', erro); }

  // todas as avaliações: janela na própria página. Dados: as avaliações do Temalli CRM gravadas no produto
  // (o tema põe em window.TEMALLI_AVALIACOES) ou, sem elas, a cópia fixa em assets/js/avaliacoes.js
  try {
    var AV = window.TEMALLI_AVALIACOES || [];
    var MESES = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
    var esc = function(t){ return String(t).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); };
    var dialogo = null;
    function montaDialogo(){
      var n5 = AV.filter(function(r){ return r.r === 5; }).length;
      var n4 = AV.filter(function(r){ return r.r === 4; }).length;
      var nf = AV.filter(function(r){ return r.f.length; }).length;
      var media = AV.reduce(function(s, r){ return s + r.r; }, 0) / AV.length;
      dialogo = document.createElement('dialog');
      dialogo.className = 'av-dialogo tml';
      dialogo.setAttribute('aria-labelledby', 'av-titulo');
      dialogo.innerHTML =
        '<div class="av-topo">' +
          '<div><b class="av-media">' + media.toFixed(2).replace('.', ',') + '</b><span class="estrelas" aria-hidden="true">★★★★★</span></div>' +
          '<div><h2 id="av-titulo">Todas as avaliações</h2><p>' + AV.length + ' avaliações reais do ' + esc(window.TML_AV_PRODUTO || 'Temalli Clássico') + '</p></div>' +
          '<button type="button" class="av-fechar" aria-label="Fechar">×</button>' +
        '</div>' +
        '<div class="av-filtros" role="group" aria-label="Filtrar avaliações">' +
          '<button type="button" data-filtro="todas" aria-pressed="true">Todas (' + AV.length + ')</button>' +
          '<button type="button" data-filtro="fotos" aria-pressed="false">Com fotos (' + nf + ')</button>' +
          '<button type="button" data-filtro="5" aria-pressed="false">5 estrelas (' + n5 + ')</button>' +
          '<button type="button" data-filtro="4" aria-pressed="false">4 estrelas (' + n4 + ')</button>' +
        '</div>' +
        '<div class="av-lista"></div>';
      document.body.appendChild(dialogo);
      var lista = dialogo.querySelector('.av-lista');
      function render(filtro){
        var itens = AV.filter(function(r){
          return filtro === 'todas' || (filtro === 'fotos' ? r.f.length : r.r === +filtro);
        });
        lista.innerHTML = itens.map(function(r){
          var d = r.d.split('-');
          var fotos = r.f.map(function(f){
            // foto mandada pelo CRM (endereço completo) ou do Judge.me (arquivo do tema)
            var src = /^https?:/.test(f) ? f : (window.TML_AV_BASE || '') + f;
            return '<button type="button" class="av-foto"><img src="' + esc(src) + '" alt="Foto enviada por ' + esc(r.n) + '" loading="lazy"></button>';
          }).join('');
          return '<article class="dep-card">' +
            '<span class="estrelas" aria-label="' + r.r + ' de 5 estrelas">' + '★★★★★'.slice(0, r.r) + '☆☆☆☆☆'.slice(0, 5 - r.r) + '</span>' +
            '<p>“' + esc(r.t) + '”</p>' + (fotos ? '<div class="av-fotos">' + fotos + '</div>' : '') +
            (r.re ? '<div class="av-resposta"><b>Resposta da Temalli</b>' + esc(r.re) + '</div>' : '') +
            '<footer><b>' + esc(r.n) + '</b><span>' + (r.c ? esc(r.c) + ' • ' : '') + d[2] + ' ' + MESES[+d[1] - 1] + ' ' + d[0] + '</span>' +
            (r.v ? '<span class="verif"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>Compra verificada</span>' : '') +
            '</footer></article>';
        }).join('');
        lista.scrollTop = 0;
      }
      dialogo.querySelectorAll('[data-filtro]').forEach(function(b){
        b.addEventListener('click', function(){
          dialogo.querySelectorAll('[data-filtro]').forEach(function(x){ x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          render(b.dataset.filtro);
        });
      });
      lista.addEventListener('click', function(e){
        var f = e.target.closest('.av-foto'); if(f) f.classList.toggle('ampliada');
      });
      dialogo.querySelector('.av-fechar').addEventListener('click', function(){ dialogo.close(); });
      dialogo.addEventListener('click', function(e){ if(e.target === dialogo) dialogo.close(); }); // clique fora
      dialogo.addEventListener('close', function(){ document.documentElement.classList.remove('sem-rolagem'); });
      render('todas');
    }
    document.querySelectorAll('[data-abrir-avaliacoes]').forEach(function(b){
      if(!AV.length){ b.hidden = true; return; }
      b.addEventListener('click', function(){
        if(!dialogo) montaDialogo();
        dialogo.showModal();
        document.documentElement.classList.add('sem-rolagem');
      });
    });
  } catch(erro){ falhou('avaliações', erro); }

  // glossário (i): textos num lugar só; o HTML usa <button class="info" data-termo="sca">
  try {
    var GLOSSARIO = {
      garantia: ['Garantia de satisfação', 'É uma política da Temalli®: se o café não agradar, devolvemos o seu dinheiro. Fazemos isso porque confiamos no que plantamos, torramos e enviamos. Vale para qualquer produto da loja, por até 7 dias depois do recebimento, mesmo com o pacote aberto. É só falar com a gente.'],
      catuai: ['Catuaí', 'Uma das variedades de arábica mais tradicionais do Brasil, desenvolvida pelo Instituto Agronômico de Campinas. Dá cafés doces, equilibrados e de corpo médio, com notas de caramelo e chocolate.'],
      natural: ['Processo natural', 'O fruto do café seca inteiro, com a casca, antes de o grão ser retirado. Durante a secagem o grão absorve açúcares da polpa, o que deixa a bebida mais doce e encorpada.'],
      sca: ['SCA', 'Specialty Coffee Association, entidade internacional que define como cafés são avaliados. Provadores certificados dão notas de 0 a 100. A partir de 80 pontos o café é considerado especial; a maioria do café vendido no mercado fica abaixo disso.'],
      mole: ['Bebida mole', 'Classificação brasileira da prova de xícara, feita por provadores. “Mole” indica um café suave e adocicado, sem aspereza nem adstringência. É o oposto das bebidas “dura” e “rio”, de gosto áspero e medicinal, comuns nos cafés de mercado.'],
      corpo: ['Corpo', 'É a textura e o “peso” do café na boca, como a diferença entre leite desnatado e integral. Corpo cremoso é denso e aveludado; equilibrado fica no meio, nem ralo nem pesado.'],
      acidez: ['Acidez', 'Não é azedume nem causa azia: é a vivacidade que dá brilho ao sabor, como numa fruta madura. Acidez equilibrada aparece sem dominar a xícara.'],
      torra: ['Torra média', 'Ponto entre a torra clara e a escura. Preserva a doçura e as notas naturais do grão, sem o amargor de queimado das torras escuras usadas para disfarçar grãos de baixa qualidade.'],
      arabica: ['100% Arábica', 'Coffea arabica, a espécie de café mais valorizada do mundo. É mais aromática e doce que o robusta (conilon), com menos amargor. Todo café especial é arábica.'],
      notas: ['Notas sensoriais', 'Aromas e sabores que o próprio grão revela, por causa da variedade, do solo, do clima e da torra. Nada é adicionado: o caramelo e as frutas que você sente vêm do café.'],
      finalizacao: ['Finalização', 'Também chamada de retrogosto: é o sabor que fica na boca depois de engolir. Um final longo e limpo, sem amargor, é sinal de café de qualidade.'],
      docura: ['Doçura', 'Doçura natural do grão colhido maduro e bem torrado. Café especial bom costuma dispensar o açúcar.'],
      suspensa: ['Secagem suspensa', 'Os grãos secam sobre telas elevadas do chão, com o ar circulando por baixo. A secagem fica mais uniforme e limpa, o que preserva aromas e doçura.'],
      arara: ['Variedade Arara', 'Cultivar de arábica brasileira, de frutos amarelos, desenvolvida pela Fundação Procafé. É conhecida pela resistência natural a doenças e pela bebida doce e de boa qualidade.'],
      colheita: ['Colheita manual', 'Os frutos são colhidos à mão, escolhendo os que estão no ponto ideal de maturação. Dá mais trabalho, mas evita grãos verdes ou passados na xícara.'],
      terroir: ['Terroir', 'O conjunto de solo, clima, altitude e manejo de um lugar. É o que dá identidade ao café, como acontece com o vinho e com o queijo da Canastra.'],
      defeitos: ['Defeitos', 'Grãos imperfeitos ou impurezas encontrados numa amostra: grãos pretos, ardidos (fermentados), verdes, brocados (furados por inseto) e quebrados, além de cascas, paus e pedras. Quanto menos defeitos, mais limpo e doce o café.'],
      graos: ['Em grãos ou moído', 'Em grãos você mói na hora, e o aroma fica mais preservado. O moído vem pronto, com moagem média para coador, cafeteira elétrica, italiana e prensa.']
    };
    var tip = document.createElement('div');
    tip.id = 'glossario-tip'; tip.setAttribute('role','tooltip');
    document.body.appendChild(tip);
    var atual = null, fixo = false; // fixo = aberto por clique/toque (não fecha ao tirar o mouse)
    function abre(btn){
      var t = GLOSSARIO[btn.dataset.termo]; if(!t) return;
      if(atual && atual !== btn){ atual.setAttribute('aria-expanded','false'); atual.removeAttribute('aria-describedby'); }
      atual = btn;
      tip.innerHTML = '<b>' + t[0] + '</b>' + t[1] + (btn.dataset.termo === 'sca' && document.getElementById('piramide') && !btn.closest('#piramide') ? ' <a href="#piramide" class="tip-link">Ver a pirâmide do café</a>' : '');
      tip.classList.add('on');
      btn.setAttribute('aria-expanded','true');
      btn.setAttribute('aria-describedby','glossario-tip');
      var r = btn.getBoundingClientRect(), w = tip.offsetWidth, h = tip.offsetHeight, m = 12;
      var left = Math.min(Math.max(m, r.left + r.width/2 - w/2), window.innerWidth - w - m);
      var top = r.top - h - 10; if(top < m) top = r.bottom + 10;
      tip.style.left = left + 'px'; tip.style.top = top + 'px';
    }
    function fecha(){
      tip.classList.remove('on');
      if(atual){ atual.setAttribute('aria-expanded','false'); atual.removeAttribute('aria-describedby'); }
      atual = null; fixo = false;
    }
    var temHover = window.matchMedia('(hover:hover)').matches;
    document.querySelectorAll('.info[data-termo]').forEach(function(btn){
      btn.type = 'button';
      btn.setAttribute('aria-expanded','false');
      if(!btn.getAttribute('aria-label')) btn.setAttribute('aria-label','O que é ' + (GLOSSARIO[btn.dataset.termo]||[''])[0] + '?');
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        if(atual === btn && fixo){ fecha(); return; }
        abre(btn); fixo = true;
      });
      if(temHover){
        btn.addEventListener('mouseenter', function(){ if(!fixo) abre(btn); });
        btn.addEventListener('mouseleave', function(){ if(!fixo) fecha(); });
      }
      btn.addEventListener('keyup', function(e){ if(e.key === 'Tab') abre(btn); }); // foco via teclado
      btn.addEventListener('blur', function(){ if(!fixo) fecha(); });
    });
    document.addEventListener('click', function(e){ if(atual && !tip.contains(e.target)) fecha(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') fecha(); });
    window.addEventListener('scroll', function(){ if(atual) fecha(); }, {passive:true});
  } catch(erro){ falhou('glossário', erro); }

  // vídeos do YouTube: só carregam ao clicar (página mais leve)
  try {
    document.addEventListener('click', function(e){
      var b = e.target.closest('[data-yt]'); if(!b) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + b.dataset.yt + '?autoplay=1&playsinline=1&rel=0';
      f.title = b.getAttribute('aria-label') || 'Vídeo';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      b.replaceWith(f);
    });
  } catch(erro){ falhou('vídeos', erro); }

  // vídeos do produto (faixa antes do ritual): tocam sem som só enquanto aparecem; o clique abre em HD, com som.
  // Com mais vídeos do que cabem, as setas andam um vídeo por vez (no celular, arrasta).
  try {
    var faixasVideo = document.querySelectorAll('[data-videos]');
    if(faixasVideo.length){
      var calmoV = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      var obsV = !calmoV && 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
        es.forEach(function(en){
          var v = en.target;
          if(en.isIntersecting){ var tocar = v.play(); if(tocar && tocar.catch){ tocar.catch(function(){}); } } else { v.pause(); }
        });
      }, {threshold: .6}) : null;
      var modalV = document.createElement('dialog');
      modalV.className = 'video-modal tml';
      modalV.setAttribute('aria-label', 'Vídeo');
      modalV.innerHTML = '<button type="button" class="video-fechar" aria-label="Fechar vídeo">×</button><video controls playsinline></video>';
      document.body.appendChild(modalV);
      var mv = modalV.querySelector('video');
      modalV.addEventListener('click', function(e){ if(e.target === modalV || e.target.closest('.video-fechar')){ modalV.close(); } });
      modalV.addEventListener('close', function(){
        mv.pause(); mv.removeAttribute('src'); mv.load();
        document.documentElement.classList.remove('sem-rolagem');
        // volta a tocar (sem som) o que está na tela
        if(obsV){ faixasVideo.forEach(function(f){ f.querySelectorAll('video').forEach(function(v){ var r = v.getBoundingClientRect(); if(r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth){ v.play().catch(function(){}); } }); }); }
      });
      faixasVideo.forEach(function(f){
        var lista = f.querySelector('.videos-lista');
        // a CDN da Shopify às vezes falha um arquivo (502) e o card fica escuro: tenta de novo e, na segunda falha, usa a versão HD
        f.querySelectorAll('video').forEach(function(v){
          var fonte = v.querySelector('source'), falhas = 0;
          if(!fonte){ return; }
          fonte.addEventListener('error', function(){
            falhas++;
            var atual = fonte.getAttribute('src'), hd = v.closest('[data-video]').dataset.hd;
            var outra = falhas === 1 ? atual + (atual.indexOf('?') > -1 ? '&' : '?') + 'r=' + Date.now() : falhas === 2 && hd && atual.indexOf(hd) !== 0 ? hd : null;
            if(!outra){ return; }
            setTimeout(function(){
              fonte.setAttribute('src', outra); v.load();
              var r = v.getBoundingClientRect();
              if(obsV && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth){ v.play().catch(function(){}); }
            }, 1500);
          });
        });
        // na loja o card toca a menor versão do vídeo (no HTML a Shopify só entrega a de 1080p): ela vem do /products/{handle}.js
        var observar = function(){ if(obsV){ f.querySelectorAll('video').forEach(function(v){ obsV.observe(v); }); } };
        if(f.dataset.produto && window.fetch){
          fetch('/products/' + f.dataset.produto + '.js', {headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); }).then(function(prod){
            (prod.media || []).forEach(function(md){
              var mp4 = (md.sources || []).filter(function(s){ return s.format === 'mp4'; }).sort(function(a, b){ return a.height - b.height; })[0];
              var card = mp4 && f.querySelector('[data-media="' + md.id + '"]');
              var fonte = card && card.querySelector('source');
              if(fonte && fonte.getAttribute('src') !== mp4.url){ fonte.setAttribute('src', mp4.url); card.querySelector('video').load(); }
            });
          }).catch(function(){}).then(observar);
        } else { observar(); }
        function setas(){
          var a = f.querySelector('[data-videos-nav="-1"]'), b = f.querySelector('[data-videos-nav="1"]');
          f.classList.toggle('rola', lista.scrollWidth > lista.clientWidth + 4);
          a.disabled = lista.scrollLeft < 4;
          b.disabled = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 4;
        }
        f.addEventListener('click', function(e){
          var card = e.target.closest('[data-video]'), nav = e.target.closest('[data-videos-nav]');
          if(card){
            var v = card.querySelector('video'), fonte = card.dataset.hd || (v.querySelector('source') || {}).src;
            f.querySelectorAll('video').forEach(function(x){ x.pause(); });
            mv.poster = v.poster; mv.src = fonte;
            modalV.showModal(); document.documentElement.classList.add('sem-rolagem');
            mv.currentTime = 0; var p = mv.play(); if(p && p.catch){ p.catch(function(){}); }
          }
          if(nav){
            var li = lista.querySelector('li');
            lista.scrollBy({left: (li ? li.offsetWidth + 20 : 300) * (+nav.dataset.videosNav), behavior: calmoV ? 'auto' : 'smooth'});
          }
        });
        lista.addEventListener('scroll', setas, {passive: true});
        window.addEventListener('resize', setas);
        setas();
      });
    }
  } catch(erro){ falhou('vídeos do produto', erro); }


  // carrinho real da Shopify (AJAX Cart API)
  var API = {
    carrinho: function(){ return fetch('/cart.js', {headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); }); },
    prazo: function(cep){ return fetch('/apps/temalli/prazo?cep=' + cep, {headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); }); },
    freteRegras: function(){ return fetch('/apps/temalli/frete', {headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); }); },
    alterar: function(linha, qtd){ return fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({line: linha, quantity: Math.max(0, qtd)})}).then(function(r){ return r.json(); }); },
    // tira todas as linhas de um café de uma vez (a Shopify pode ter dividido o café em várias linhas por causa do desconto)
    remover: function(chaves){ var u = {}; chaves.forEach(function(k){ u[k] = 0; }); return fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({updates: u})}).then(function(r){ if(!r.ok){ throw r; } return r.json(); }); },
    adicionar: function(itens){ return fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: itens})}).then(function(r){ if(!r.ok){ throw r; } return r.json(); }); },
    checkout: function(){ return CFG.checkout || '/checkout'; },
    // parceiros: dados da página (Temalli CRM pelo App Proxy), atributo do carrinho e cupom
    parceiro: function(apelido){ return fetch('/apps/temalli/parceiro?p=' + encodeURIComponent(apelido), {headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); }); },
    marcarParceiro: function(apelido){ return fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({attributes: {parceiro: apelido}})}).then(function(r){ if(!r.ok){ throw r; } return r.json(); }); },
    aplicarCupom: function(codigo, apelido){ return fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({discount: codigo, attributes: {parceiro: apelido}})}).then(function(r){ if(!r.ok){ throw r; } return r.json(); }); },
    // convite de primeira compra (Temalli CRM pelo App Proxy): o convite (uma vez por sessão), o cupom e o carrinho
    convite: function(){
      try { var s = sessionStorage.getItem('tml_pc_convite'); if(s){ return Promise.resolve(JSON.parse(s)); } } catch(e){}
      return fetch('/apps/temalli/primeira-compra', {headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); })
        .then(function(cv){ try { sessionStorage.setItem('tml_pc_convite', JSON.stringify(cv)); } catch(e){} return cv; });
    },
    pedirCupom: function(dados){ return fetch('/apps/temalli/primeira-compra', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(dados)}).then(function(r){ return r.json(); }); },
    cupomPrimeiraCompra: function(codigo){ return fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({discount: codigo})}).then(function(r){ if(!r.ok){ throw r; } return r.json(); }); }
  };

  // ===== gaveta de carrinho (mesmo desenho no tema e no protótipo; muda só a API) =====
  var CFG = window.TML_CARRINHO || {};
  var gaveta = document.querySelector('[data-gaveta]');
  var paginaCarrinho = document.querySelector('[data-carrinho-pagina]');
  function dinheiro(c){ return (c / 100).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}); }
  function esc(t){ return String(t == null ? '' : t).replace(/[&<>"]/g, function(x){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[x]; }); }
  function nomeCurto(t){ return String(t || '').split('•')[0].trim(); }
  function bonito(v){ return String(v || '').split('•').map(function(p){ p = p.trim(); return /^\d/.test(p) ? p : p.charAt(0) + p.slice(1).toLowerCase(); }).join(' • '); }
  function miniatura(u){ if(!u || u.indexOf('cdn.shopify') < 0){ return u || ''; } return /width=\d+/.test(u) ? u.replace(/width=\d+/, 'width=160') : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
  function ehKit(id){ return (CFG.kits || []).map(String).indexOf(String(id)) > -1; }
  var VAZIO_XICARA = '<span class="xicara-vapor" aria-hidden="true"><span class="vapor"><i></i><i></i><i></i></span><svg viewBox="0 0 44 34" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6h26v10a11 11 0 01-11 11h-4A11 11 0 016 16z"/><path d="M32 9h3a5 5 0 010 10h-3"/><path d="M3 31h34"/></svg></span>';

  var ultimo = {items: []};   // último carrinho recebido: as ações da gaveta usam as linhas reais dele
  var ICONE_PACOTE = '<svg viewBox="0 0 24 32"><path d="M5 4h14l2 26H3z" fill="currentColor"/><path d="M5 4h14v3H5z" fill="currentColor" opacity=".55"/></svg>';
  var brindesVistos = {};     // brindes por café no desenho anterior (para destacar quando ganha um novo)
  var ICONE_PRESENTE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="8.5" width="17" height="4" rx="1"/><path d="M5 12.5v7a1 1 0 001 1h12a1 1 0 001-1v-7M12 8.5v12"/><path d="M12 8.5C10.5 5 7 4.5 7 6.6 7 8.5 12 8.5 12 8.5zM12 8.5c1.5-3.5 5-4 5-1.9 0 1.9-5 1.9-5 1.9z"/></svg>';
  function desenha(c, raiz, naGaveta){
    ultimo = c;
    // frete grátis do estado do visitante (regras do CRM); null: sem frete grátis no estado
    var ufFrete = regrasFrete ? ufVisitante() : null, minimo = regrasFrete ? limiteDoUF(ufFrete) : (CFG.freteMinimo || 15000);
    var astFrete = !ufFrete && regrasFrete && temExcecoes() ? '*' : '';
    var cont = raiz.querySelector('[data-gav-count]');
    if(cont){ cont.textContent = c.item_count ? '(' + c.item_count + (c.item_count > 1 ? ' itens)' : ' item)') : ''; }
    document.querySelectorAll('.nav-carrinho').forEach(function(a){
      var s = a.querySelector('span');
      if(c.item_count){ if(!s){ s = document.createElement('span'); a.appendChild(s); } s.textContent = c.item_count; } else if(s){ s.remove(); }
    });
    var frete = raiz.querySelector('[data-gav-frete]'), corpo = raiz.querySelector('[data-gav-corpo]'), rodape = raiz.querySelector('[data-gav-rodape]');
    if(!c.item_count){
      frete.innerHTML = ''; rodape.innerHTML = '';
      corpo.innerHTML = '<div class="gav-vazio">' + VAZIO_XICARA + '<h3>Seu carrinho está vazio</h3><p>Que tal começar pelo café da casa?</p>' +
        (CFG.links || []).map(function(l){ return '<a class="btn ' + (l.classe || '') + '" href="' + l.url + '">' + esc(l.texto) + '</a>'; }).join('') + '</div>';
      return;
    }
    var regrasLink = ' <button type="button" class="gav-regras" data-frete-abrir>' + (ufFrete ? 'regras' : 'ver pelo CEP') + '</button>';
    if(minimo == null){
      frete.innerHTML = '<div class="gav-frete">O frete para ' + esc(ufFrete || 'o seu estado') + ' é calculado no checkout.' + regrasLink + '</div>';
    } else if(c.total_price >= minimo){
      frete.innerHTML = '<div class="gav-frete ok"><b>Seu pedido tem frete grátis' + astFrete + '</b>' + (ufFrete ? ' para ' + esc(ufFrete) + '.' : '.') + regrasLink + '<div class="gav-trilho"><i style="--p:100%"></i></div></div>';
    } else {
      frete.innerHTML = '<div class="gav-frete">Faltam <b>' + dinheiro(minimo - c.total_price) + '</b> para o frete grátis' + (ufFrete ? ' para ' + esc(ufFrete) : astFrete) + '.' + regrasLink + '<div class="gav-trilho"><i style="--p:' + Math.round(c.total_price / minimo * 100) + '%"></i></div></div>';
    }
    var noCarrinho = c.items.map(function(it){ return String(it.product_id); });
    // a Shopify divide o mesmo café em várias linhas quando aplica o "Pague 3, Leve 4" (ex.: 1 + 1 grátis + 3):
    // na gaveta cada café/variante aparece uma vez só, e as unidades grátis ganham uma faixa de brinde
    var grupos = [], porVar = {};
    c.items.forEach(function(it){
      var g = porVar[it.variant_id];
      if(!g){ g = porVar[it.variant_id] = {it: it, quantidade: 0, original: 0, final: 0, desc: 0}; grupos.push(g); }
      g.quantidade += it.quantity; g.original += it.original_line_price; g.final += it.final_line_price;
      g.desc += (it.line_level_discount_allocations || []).reduce(function(s, a){ return s + a.amount; }, 0);
    });
    var totalKit = 0, varBrinde = null, menor = Infinity;
    grupos.forEach(function(g){
      if(!ehKit(g.it.product_id)){ return; }
      totalKit += g.quantidade;
      var unit = g.original / g.quantidade;
      if(unit < menor){ menor = unit; varBrinde = g.it.variant_id; }
    });
    // quantos pacotes faltam para o próximo 4º grátis (1, 2 ou 3); 0 = o kit já fechou
    var falta = totalKit ? (4 - totalKit % 4) % 4 : 0;
    // cafés de preços diferentes no carrinho: avisar que o grátis é sempre o de menor valor (regra do desconto)
    var precosKit = {};
    grupos.forEach(function(g){ if(ehKit(g.it.product_id)){ precosKit[Math.round(g.original / g.quantidade)] = 1; } });
    var misto = Object.keys(precosKit).length > 1;
    if(!falta){ varBrinde = null; }
    var brindesAntes = brindesVistos; brindesVistos = {};
    var itens = grupos.map(function(g){
      var it = g.it, v = it.variant_id, unit = g.original / g.quantidade;
      var gratis = g.desc ? Math.round(g.desc / unit) : 0;
      brindesVistos[v] = gratis;
      // compre 3, ganhe 1 (vale misturado): faltando 1 pacote, o aviso fica no café mais barato, que é o que sai de graça
      // upsell do kit: 4 pacotinhos mostram onde a pessoa está (tem / faltam / o grátis) e o botão diz quanto custa a mais.
      // O 4º sai de graça, então completar o kit custa (faltam - 1) pacotes.
      var aviso = '';
      if(v === varBrinde){
        var tem = 4 - falta, extra = (falta - 1) * unit;
        var pacs = '';
        for(var k = 0; k < 4; k++){ pacs += '<i class="' + (k === 3 ? 'gratis' : k < tem ? 'tem' : 'falta') + '">' + ICONE_PACOTE + '</i>'; }
        aviso = '<div class="gav-upsell"><div class="gav-up-topo"><span class="gav-up-pacs" aria-hidden="true">' + pacs + '</span><div>' +
          '<b>' + (falta === 1 ? 'Falta 1 para o kit: ele sai de graça' : 'Complete o kit e ganhe o 4º pacote') + '</b>' +
          '<small>Pague 3, leve 4 + frete grátis</small></div></div>' +
          '<button type="button" class="gav-up-btn" data-gav-acao="mais" data-gav-n="' + falta + '" data-gav-var="' + v + '">' +
          (falta === 1 ? 'Adicionar o 4º pacote grátis' : 'Adicionar ' + falta + ' pacotes • + ' + dinheiro(extra)) + '</button></div>';
      }
      var presente = gratis
        ? '<div class="gav-presente' + (gratis > (brindesAntes[v] || 0) && brindesAntes._pronto ? ' novo' : '') + '"><span class="gav-presente-ic" aria-hidden="true">' + ICONE_PRESENTE + '</span>' +
          '<div><b>' + gratis + (gratis > 1 ? ' unidades' : ' unidade') + ' de brinde</b><small>' + (misto ? 'Pague 3, Leve 4 • sai grátis o de menor valor' : 'Pague 3, Leve 4') + '</small></div>' +
          '<div class="gav-presente-valor"><s>' + dinheiro(g.desc) + '</s><span>Grátis</span></div></div>' : '';
      return '<div class="gav-item" data-gav-item="' + v + '"><img src="' + esc(miniatura(it.image)) + '" alt="" width="76" height="76" loading="eager" decoding="async"><div class="gav-info">' +
        '<div class="gav-linha1"><div><a class="gav-nome" href="' + esc(it.url) + '">' + esc(nomeCurto(it.product_title)) + '</a><span class="gav-var">' + esc(bonito(it.variant_title)) + '</span></div>' +
        '<div class="gav-preco">' + (g.desc ? '<s>' + dinheiro(g.original) + '</s>' : '') + dinheiro(g.final) + '</div></div>' +
        '<div class="gav-linha2"><div class="gav-qtd"><button type="button" data-gav-acao="menos" data-gav-var="' + v + '" aria-label="Menos um">−</button><output>' + g.quantidade + '</output>' +
        '<button type="button" data-gav-acao="mais" data-gav-var="' + v + '" aria-label="Mais um">+</button></div>' +
        '<button type="button" class="gav-remover" data-gav-acao="remover" data-gav-var="' + v + '">Remover</button></div></div>' + presente + aviso + '</div>';
    }).join('');
    brindesVistos._pronto = true;
    var sug = (CFG.sugestoes || []).filter(function(s){ return noCarrinho.indexOf(String(s.produtoId)) < 0; })[0];
    var sugHtml = sug ? '<div class="gav-sugestao"><small>Que tal provar também?</small><div class="gav-sug"><img src="' + esc(sug.img) + '" alt="" width="56" height="56" loading="lazy">' +
      '<div><b>' + esc(sug.titulo) + '</b><span>' + esc(sug.descricao) + ' • ' + dinheiro(sug.preco) + '</span></div>' +
      '<button type="button" data-gav-add="' + sug.variantId + '">Adicionar</button></div></div>' : '';
    corpo.innerHTML = itens + sugHtml;
    // cupom (desconto no pedido, ex.: o do parceiro): uma linha com o código e o valor
    var cupons = (c.cart_level_discount_applications || []).map(function(a){
      return '<div class="gav-cupom"><span>Cupom ' + esc(a.title) + '</span><span>− ' + dinheiro(a.total_allocated_amount) + '</span></div>';
    }).join('');
    rodape.innerHTML = '<div class="gav-rodape">' + cupons +
      (c.total_discount ? '<div class="gav-eco"><span>Você economiza</span><span>' + dinheiro(c.total_discount) + '</span></div>' : '') +
      '<div class="gav-total"><span>Total</span><b>' + dinheiro(c.total_price) + '</b></div>' +
      '<div class="prazo prazo-gav" data-prazo data-prazo-compacto></div>' +
      '<p class="gav-nota">' + (minimo != null && c.total_price >= minimo ? 'Frete grátis. ' : regrasFrete && regrasFrete.ativo ? 'Frete calculado no checkout pelo seu CEP. ' : CFG.freteValor ? 'Frete de ' + dinheiro(CFG.freteValor) + '. ' : 'Frete calculado na próxima etapa. ') + 'Pague com Pix ou no cartão em até 6x sem juros, em ambiente 100% seguro.</p>' +
      '<a class="btn btn-bloco" href="' + esc(API.checkout(c)) + '" data-gav-checkout>Finalizar compra</a>' +
      (naGaveta ? '<button type="button" class="gav-continuar" data-gav-fechar>Continuar comprando</button>' : '') + '</div>';
    pintarPrazos();
  }
  // ===== prazo de entrega por CEP (página do café e gaveta; mesmo código no tema e no protótipo) =====
  // O Temalli CRM cota o transporte no Melhor Envio (API.prazo, dias úteis); sem resposta, vale a estimativa por
  // estado saindo de São José do Rio Preto. A data soma a postagem (CFG.postagemDias) e pula fim de semana e feriado.
  var UF_CEP = [[1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'], [40000, 48999, 'BA'], [49000, 49999, 'SE'],
    [50000, 56999, 'PE'], [57000, 57999, 'AL'], [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'], [69300, 69399, 'RR'], [69400, 69899, 'AM'],
    [69900, 69999, 'AC'], [70000, 72799, 'DF'], [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [79000, 79999, 'MS'], [80000, 87999, 'PR'], [88000, 89999, 'SC'], [90000, 99999, 'RS']];
  var PRAZO_UF = {SP: [1, 3], MG: [2, 5], RJ: [2, 5], PR: [2, 5], GO: [2, 5], DF: [2, 5], MS: [2, 5], ES: [3, 6], SC: [3, 6], RS: [3, 6], MT: [3, 6],
    BA: [5, 9], SE: [5, 9], AL: [5, 9], PE: [5, 9], PB: [5, 9], RN: [5, 9], CE: [5, 9], PI: [5, 9], MA: [5, 9], TO: [5, 9], RO: [6, 10],
    PA: [7, 12], AM: [7, 12], AP: [7, 12], RR: [7, 12], AC: [7, 12]};
  var FERIADOS = ['01-01', '04-21', '05-01', '09-07', '10-12', '11-02', '11-15', '11-20', '12-25'];
  var SEMANA = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
  var ICONE_CAMINHAO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3.2v2.8h-7"/><circle cx="6.5" cy="17" r="1.8"/><circle cx="17" cy="17" r="1.8"/></svg>';
  var prazo = {cep: '', digitado: '', res: null, erro: '', carregando: false};
  function ufDoCep(cep){
    var n = +cep.slice(0, 5);
    for(var i = 0; i < UF_CEP.length; i++){ if(n >= UF_CEP[i][0] && n <= UF_CEP[i][1]){ return UF_CEP[i][2]; } }
    return null;
  }
  function cepBonito(c){ return c.length > 5 ? c.slice(0, 5) + '-' + c.slice(5, 8) : c; }
  function maisDiasUteis(n){
    var d = new Date();
    while(n > 0){
      d.setDate(d.getDate() + 1);
      var md = ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      if(d.getDay() !== 0 && d.getDay() !== 6 && FERIADOS.indexOf(md) < 0){ n--; }
    }
    return d;
  }
  function dataCurta(d){ return SEMANA[d.getDay()] + ', ' + ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2); }
  function textoPrazo(r){
    var post = CFG.postagemDias || 2, de = maisDiasUteis(post + r.min), ate = maisDiasUteis(post + r.max);
    return r.min === r.max ? 'Chega até ' + dataCurta(ate) : 'Chega entre ' + dataCurta(de) + ' e ' + dataCurta(ate);
  }
  function htmlPrazo(compacto, id){
    var p = prazo, topo = '<span class="prazo-ic">' + ICONE_CAMINHAO + '</span>';
    if(p.res){
      var nota = (p.res.uf ? 'Estimativa para ' + p.res.uf : 'Transporte ' + p.res.transp) + ', com postagem em até ' + (CFG.postagemDias || 2) + ' dias úteis.';
      return topo + '<div class="prazo-res" aria-live="polite"><b>' + textoPrazo(p.res) + '</b>' + (compacto ? '' : '<small>' + esc(nota) + '</small>') + '</div>' +
        '<button type="button" class="prazo-trocar" data-prazo-trocar aria-label="Trocar o CEP ' + cepBonito(p.cep) + '">' + (compacto ? '' : cepBonito(p.cep) + ' ') + '<u>alterar</u></button>';
    }
    return topo + '<label class="prazo-rotulo" for="' + id + '">Prazo de entrega</label>' +
      '<div class="prazo-campo"><input id="' + id + '" type="text" inputmode="numeric" autocomplete="postal-code" maxlength="9" placeholder="Seu CEP" value="' + esc(p.digitado) + '" data-prazo-cep>' +
      '<button type="button" data-prazo-ok' + (p.carregando ? ' disabled' : '') + '>' + (p.carregando ? 'Calculando…' : compacto ? 'Ver prazo' : 'Calcular') + '</button></div>' +
      (p.erro ? '<p class="prazo-erro" role="alert">' + esc(p.erro) + '</p>' : '');
  }
  function pintarPrazos(){
    document.querySelectorAll('[data-prazo]').forEach(function(el, i){
      el.classList.toggle('tem-res', !!prazo.res);
      el.innerHTML = htmlPrazo(el.hasAttribute('data-prazo-compacto'), 'prazo-cep-' + i);
    });
  }
  function estimativa(cep){ var uf = ufDoCep(cep), f = uf && PRAZO_UF[uf]; return f ? {min: f[0], max: f[1], uf: uf} : null; }
  function calcularPrazo(bruto, calado){
    var cep = String(bruto || '').replace(/\D/g, '');
    if(cep.length !== 8){ if(!calado){ prazo.erro = 'Digite os 8 números do CEP.'; pintarPrazos(); } return; }
    var guardado = null;
    try { guardado = JSON.parse(sessionStorage.getItem('tml_prazo_' + cep) || 'null'); } catch(e){}
    function pronto(r){
      prazo.carregando = false;
      if(!r){ prazo.erro = 'Não encontramos este CEP. Confira os números.'; pintarPrazos(); return; }
      prazo.cep = cep; prazo.res = r; prazo.erro = ''; prazo.digitado = cepBonito(cep);
      try { localStorage.setItem('tml_cep', cep); sessionStorage.setItem('tml_prazo_' + cep, JSON.stringify(r)); } catch(e){}
      pintarPrazos();
      if(typeof pintarFrete === 'function' && regrasFrete){ pintarFrete(); }
    }
    if(guardado){ pronto(guardado); return; }
    prazo.carregando = true; prazo.erro = ''; prazo.digitado = cepBonito(cep); pintarPrazos();
    var limite = new Promise(function(ok, falha){ setTimeout(function(){ falha(new Error('sem resposta')); }, 9000); });
    Promise.race([API.prazo(cep), limite])
      .then(function(r){ if(!r || !r.ok){ throw new Error(r && r.erro); } pronto({min: r.min, max: r.max, transp: r.transportadora || 'pela transportadora'}); })
      .catch(function(){ pronto(estimativa(cep)); });
  }
  document.addEventListener('input', function(e){
    var i = e.target.closest && e.target.closest('[data-prazo-cep]');
    if(!i){ return; }
    var d = i.value.replace(/\D/g, '').slice(0, 8);
    i.value = cepBonito(d); prazo.digitado = i.value;
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Enter' && e.target.closest && e.target.closest('[data-prazo-cep]')){ e.preventDefault(); calcularPrazo(e.target.value); }
  });
  document.addEventListener('click', function(e){
    var ok = e.target.closest('[data-prazo-ok]'), trocar = e.target.closest('[data-prazo-trocar]');
    if(ok){ calcularPrazo(ok.closest('[data-prazo]').querySelector('[data-prazo-cep]').value); }
    if(trocar){
      var caixa = trocar.closest('[data-prazo]');
      prazo.res = null; prazo.digitado = ''; pintarPrazos();
      var campo = caixa && caixa.querySelector('[data-prazo-cep]');
      if(campo){ campo.focus(); }
    }
  });
  try { var cepSalvo = localStorage.getItem('tml_cep'); if(cepSalvo){ calcularPrazo(cepSalvo, true); } } catch(e){}
  pintarPrazos();

  // ===== frete grátis por estado (mesmo código no tema e no protótipo) =====
  // O valor do frete grátis vem do Temalli CRM (API.freteRegras: o padrão e as exceções por estado, as mesmas do
  // frete no checkout); sem resposta, vale CFG.freteMinimo. Com o CEP do visitante (o do prazo de entrega), as
  // mensagens passam a ser as do estado dele. Tocar numa mensagem de frete abre as regras por região e o CEP.
  var REGIOES_FRETE = [['Sudeste', ['SP', 'RJ', 'MG', 'ES']], ['Sul', ['PR', 'SC', 'RS']], ['Centro-Oeste', ['DF', 'GO', 'MS', 'MT']],
    ['Nordeste', ['BA', 'SE', 'AL', 'PE', 'PB', 'RN', 'CE', 'PI', 'MA']], ['Norte', ['TO', 'PA', 'AM', 'AP', 'RR', 'RO', 'AC']]];
  var regrasFrete = {padrao: (CFG.freteMinimo || 15000) / 100, porUF: {}, ativo: false};
  var dlgFrete = null;
  function ufVisitante(){
    var c = prazo.cep;
    if(!c){ try { c = localStorage.getItem('tml_cep') || ''; } catch(e){ c = ''; } }
    return c.length === 8 ? ufDoCep(c) : null;
  }
  // em centavos; null: sem frete grátis no estado (sem estado, vale o padrão)
  function limiteDoUF(uf){
    var v = uf && Object.prototype.hasOwnProperty.call(regrasFrete.porUF, uf) ? regrasFrete.porUF[uf] : regrasFrete.padrao;
    return v == null ? null : Math.round(v * 100);
  }
  function temExcecoes(){ return Object.keys(regrasFrete.porUF || {}).length > 0; }
  function textoFreteGratis(){
    var uf = ufVisitante(), lim = limiteDoUF(uf);
    if(lim == null){ return uf ? 'Frete para ' + uf + ' calculado pelo CEP' : 'Frete calculado pelo CEP'; }
    return 'Frete grátis ' + (uf ? 'para ' + uf + ' ' : '') + (lim ? 'a partir de ' + reaisFrete(lim) : 'em todo pedido') + (uf || !temExcecoes() ? '' : '*');
  }
  // Regras por região: o valor da maioria dos estados e as exceções
  function reaisFrete(c){ return dinheiro(c).replace(/,00$/, ''); }   // R$ 150 (sem centavos quando redondo)
  function valorFrete(c){ return c == null ? 'sem frete grátis' : c ? 'a partir de ' + reaisFrete(c) : 'em todo pedido'; }
  function htmlRegioes(){
    return REGIOES_FRETE.map(function(r){
      var grupos = {};
      r[1].forEach(function(u){ var k = String(limiteDoUF(u)); (grupos[k] = grupos[k] || []).push(u); });
      var chaves = Object.keys(grupos).sort(function(a, b){ return grupos[b].length - grupos[a].length; });
      var principal = chaves[0], txt = valorFrete(principal === 'null' ? null : +principal);
      var outras = chaves.slice(1).map(function(k){ return grupos[k].join(', ') + ': ' + valorFrete(k === 'null' ? null : +k); });
      return '<li><b>' + r[0] + '</b><span>' + (outras.length ? txt + ' (' + esc(outras.join('; ')) + ')' : txt) + '</span></li>';
    }).join('');
  }
  function pintarDlgFrete(){
    if(!dlgFrete){ return; }
    var uf = ufVisitante(), lim = limiteDoUF(uf);
    var res = uf
      ? '<p class="frete-dlg-res">Para ' + cepBonito(prazo.cep || '') + ' (' + uf + '): <b>' + (lim == null ? 'frete calculado no checkout' : 'frete grátis ' + valorFrete(lim)) + '</b>.</p>'
      : '<p class="frete-dlg-res">Digite o seu CEP para ver o frete grátis e o prazo para o seu endereço.</p>';
    dlgFrete.innerHTML = '<div class="frete-dlg-caixa"><button type="button" class="frete-dlg-x" data-frete-fechar aria-label="Fechar">×</button>' +
      '<h2 id="frete-dlg-t">Frete grátis</h2>' + res + '<div class="prazo" data-prazo></div>' +
      '<h3>Por região</h3><ul class="frete-regioes">' + htmlRegioes() + '</ul>' +
      '<p class="frete-dlg-nota">Vale para a entrega padrão, sobre o valor dos produtos com os descontos. Na assinatura, todas as entregas têm frete grátis.</p></div>';
    pintarPrazos();
  }
  function abrirFrete(){
    if(!dlgFrete){
      dlgFrete = document.createElement('dialog');
      dlgFrete.className = 'frete-dlg tml';   // como a gaveta: a classe .tml leva os estilos do tema
      dlgFrete.setAttribute('aria-labelledby', 'frete-dlg-t');
      document.body.appendChild(dlgFrete);
      dlgFrete.addEventListener('click', function(e){ if(e.target === dlgFrete || e.target.closest('[data-frete-fechar]')){ dlgFrete.close(); } });
    }
    pintarDlgFrete();
    if(dlgFrete.showModal){ dlgFrete.showModal(); } else { dlgFrete.setAttribute('open', ''); }
  }
  function pintarFrete(){
    var uf = ufVisitante(), lim = limiteDoUF(uf), ast = !uf && temExcecoes() ? '*' : '';
    document.querySelectorAll('[data-frete-gratis]').forEach(function(el){ el.textContent = textoFreteGratis(); });
    document.querySelectorAll('[data-frete-valor]').forEach(function(el){
      var v = +el.getAttribute('data-frete-valor');
      el.textContent = lim != null && v >= lim ? ' • frete grátis' + ast : ' • frete à parte';
    });
    document.querySelectorAll('[data-frete-selo]').forEach(function(el){ el.hidden = !(lim != null && +el.getAttribute('data-frete-selo') >= lim); });
    document.querySelectorAll('[data-frete-ast]').forEach(function(el){ el.textContent = ast; });
    document.querySelectorAll('[data-frete-nota]').forEach(function(el){ el.hidden = !ast; });
    document.querySelectorAll('[data-frete-topo]').forEach(function(el){ el.hidden = lim == null; });
    if(dlgFrete && dlgFrete.open){ pintarDlgFrete(); }
    if(ultimo && ultimo.item_count != null){ redesenha(ultimo); }
  }
  // A faixa do topo que fala de frete abre as regras; a nota do asterisco vai no rodapé
  document.querySelectorAll('.topbar').forEach(function(t){
    if(!/frete/i.test(t.textContent)){ return; }
    t.setAttribute('role', 'button'); t.setAttribute('tabindex', '0'); t.setAttribute('data-frete-abrir', '');
    if(t.querySelector('[data-frete-gratis]')){ return; }   // faixa que já é a mensagem do frete
    // o "+ frete grátis" da faixa some no estado sem frete grátis
    t.innerHTML = t.innerHTML.replace(/(\s*\+?\s*frete grátis)/i, '<span data-frete-topo>$1<span data-frete-ast></span></span>');
    if(!t.querySelector('[data-frete-ast]')){ t.insertAdjacentHTML('beforeend', '<span data-frete-ast></span>'); }
  });
  document.querySelectorAll('.rodape-fim').forEach(function(r){
    r.insertAdjacentHTML('beforebegin', '<p class="frete-nota" data-frete-nota hidden>* O frete grátis depende do estado de entrega. <button type="button" data-frete-abrir>Ver as regras e o prazo pelo CEP</button></p>');
  });
  document.addEventListener('click', function(e){
    if(e.target.closest && e.target.closest('[data-frete-abrir], [data-frete-gratis]')){ e.preventDefault(); abrirFrete(); }
  });
  document.addEventListener('keydown', function(e){
    if((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[role=button][data-frete-abrir]')){ e.preventDefault(); abrirFrete(); }
  });
  (function(){
    var guardado = null;
    try { guardado = JSON.parse(sessionStorage.getItem('tml_frete_regras') || 'null'); } catch(e){}
    if(guardado){ regrasFrete = guardado; pintarFrete(); return; }
    pintarFrete();
    API.freteRegras().then(function(r){
      if(!r || !r.ok){ return; }
      regrasFrete = {padrao: r.padrao, porUF: r.porUF || {}, ativo: !!r.ativo};
      try { sessionStorage.setItem('tml_frete_regras', JSON.stringify(regrasFrete)); } catch(e){}
      pintarFrete();
    }).catch(function(){});
  })();

  function redesenha(c){
    if(gaveta){ desenha(c, gaveta, true); }
    if(paginaCarrinho){ desenha(c, paginaCarrinho, false); }
  }
  function abrirGaveta(){
    if(!gaveta){ return false; }
    API.carrinho().then(redesenha);
    if(!gaveta.open){ gaveta.showModal(); document.documentElement.classList.add('sem-rolagem'); }
    return true;
  }
  window.TML_ABRIR_CARRINHO = abrirGaveta;
  [gaveta, paginaCarrinho].forEach(function(raiz){
    if(!raiz){ return; }
    raiz.addEventListener('click', function(e){
      var ac = e.target.closest('[data-gav-acao]'), add = e.target.closest('[data-gav-add]');
      if(e.target.closest('[data-gav-fechar]') || e.target === gaveta){ gaveta.close(); return; }
      if(!ac && !add){ return; }
      if(raiz.classList.contains('gav-carregando')){ return; }   // um pedido por vez
      raiz.classList.add('gav-carregando');
      var p;
      if(add){
        p = API.adicionar([{id: +add.dataset.gavAdd, quantity: 1}]).then(API.carrinho);
      } else {
        var v = +ac.dataset.gavVar, acao = ac.dataset.gavAcao, n = +ac.dataset.gavN || 1;
        // linhas reais desse café no carrinho (a Shopify pode ter dividido em várias)
        var linhas = ultimo.items.map(function(it, i){ return {linha: i + 1, q: it.quantity, v: it.variant_id, chave: it.key}; }).filter(function(l){ return l.v === v; });
        var total = linhas.reduce(function(s, l){ return s + l.q; }, 0), ult = linhas[linhas.length - 1];
        // resposta na hora: o número muda já e só o preço desse café fica esperando a Shopify (nada de apagar a gaveta inteira)
        var item = raiz.querySelector('[data-gav-item="' + v + '"]'), out = item && item.querySelector('output');
        if(item){ item.classList.add('gav-atualizando'); }
        if(out){ out.textContent = acao === 'mais' ? total + n : acao === 'menos' ? Math.max(0, total - 1) : 0; }
        if(!ult){ p = API.carrinho(); }
        else if(acao === 'mais'){ p = API.alterar(ult.linha, ult.q + n); }
        else if(acao === 'menos'){ p = API.alterar(ult.linha, ult.q - 1); }
        else { p = API.remover(linhas.map(function(l){ return l.chave; }), v); }
      }
      p.then(redesenha).catch(function(){ return API.carrinho().then(redesenha); })
       .finally(function(){ raiz.classList.remove('gav-carregando'); });
    });
  });
  if(gaveta){
    gaveta.addEventListener('close', function(){ document.documentElement.classList.remove('sem-rolagem'); });
    document.addEventListener('click', function(e){
      var a = e.target.closest('.nav-carrinho');
      if(a){ e.preventDefault(); abrirGaveta(); }
    });
  }
  if(paginaCarrinho){ API.carrinho().then(redesenha); }

  // ===== parceiros: quem chega pelo link do parceiro fica marcado por 30 dias (cookies tml_parceiro, lido
  // também pelo pixel do CRM, e tml_cupom) e o carrinho leva o atributo "parceiro": a venda conta para ele
  // mesmo sem cupom. O cupom entra sozinho no carrinho (a Shopify guarda o código com o carrinho vazio e
  // aplica quando entra um produto) e volta nesses 30 dias se o carrinho estiver sem cupom; cupom de outra
  // origem nunca é trocado. Na página do parceiro, o CRM manda nome, foto, frase e cupom; o botão "Aplicar"
  // continua lá de propósito (o clique é o momento do ganho: etiquetas -R$ e -10% saem dele e os preços caem).
  try {
    var lerCookie = function(n){ var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; };
    var APELIDO_OK = /^[a-z0-9-]{2,30}$/;
    var CODIGO_OK = /^[A-Z0-9_-]{3,30}$/;
    var guardar = function(nome, valor){ document.cookie = nome + '=' + encodeURIComponent(valor) + '; max-age=' + (30 * 86400) + '; path=/; SameSite=Lax'; };
    // uma vez por sessão: cupom no carrinho sem cupom e o atributo "parceiro"; devolve true se o cupom do parceiro está no carrinho
    var marcarCarrinho = function(apelido, codigo){
      try { if(sessionStorage.getItem('tml_parc_marcado') === apelido){ return Promise.resolve(null); } } catch(e){}
      return API.carrinho().then(function(c){
        var codigos = (c.discount_codes || []).map(function(d){ return String(d.code).toUpperCase(); });
        if(codigo && codigos.indexOf(codigo) > -1){ return API.marcarParceiro(apelido).then(function(){ return true; }); }
        if(codigo && !codigos.length){ return API.aplicarCupom(codigo, apelido).then(function(){ return true; }); }
        return API.marcarParceiro(apelido).then(function(){ return false; });
      }).then(function(comCupom){ try { sessionStorage.setItem('tml_parc_marcado', apelido); } catch(e){} return comCupom; })
        .catch(function(){ return null; });
    };
    var salvo = lerCookie('tml_parceiro'), cupomSalvo = lerCookie('tml_cupom'), pctSalvo = parseFloat(lerCookie('tml_cupom_pct'));
    var paginaP = document.querySelector('[data-parceiro]');
    if(salvo && APELIDO_OK.test(salvo) && !paginaP){
      var codSalvo = CODIGO_OK.test(cupomSalvo) ? cupomSalvo : '';
      marcarCarrinho(salvo, codSalvo).then(function(){
        // página de produto: com o cupom do parceiro mesmo no carrinho, os preços mostram o valor com ele
        if(!codSalvo || !(pctSalvo > 0) || !document.querySelector('[data-buybox]')){ return; }
        return API.carrinho().then(function(c){
          if((c.discount_codes || []).some(function(d){ return String(d.code).toUpperCase() === codSalvo; })){ window.TML_CUPOM_NA_CAIXA(codSalvo, pctSalvo); }
        });
      }).catch(function(){});
    }
    if(paginaP){
      var doLink = (new URLSearchParams(location.search).get('p') || '').toLowerCase();
      var apelidoP = APELIDO_OK.test(doLink) ? doLink : (APELIDO_OK.test(salvo) ? salvo : '');
      var $p = function(sel){ return paginaP.querySelector(sel); };
      var trocaNome = function(t, parc){ return String(t || '').replace(/\[nome\]/g, parc.nome).replace(/\[pct\]/g, String(parc.desconto).replace('.', ',')); };
      var cafesP = paginaP.querySelectorAll('[data-parc-cafe]');
      var pct = 0, parcAtual = null, cupomNoCarrinho = false;
      // etiquetas -R$ / -10% saindo do botão
      var cupomVoa = function(botao, desconto){
        if(REDUZ || !botao){ return; }
        var r = botao.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        var rotulo = '−' + String(desconto).replace('.', ',') + '%';
        for(var i = 0; i < 8; i++){
          var t = document.createElement('span');
          var ang = -Math.PI / 2 + (i - 3.5) * 0.32 + (Math.random() - 0.5) * 0.2, dist = 90 + Math.random() * 60;
          t.className = 'cupom-voa';
          t.textContent = i % 2 ? rotulo : '−R$';
          t.style.left = cx + (Math.random() - 0.5) * r.width * 0.6 + 'px'; t.style.top = cy + 'px';
          t.style.setProperty('--dx', Math.round(Math.cos(ang) * dist) + 'px');
          t.style.setProperty('--dy', Math.round(Math.sin(ang) * dist) + 'px');
          t.style.setProperty('--r', Math.round(Math.random() * 30 - 15) + 'deg');
          t.style.animationDelay = (i * 45) + 'ms';
          document.body.appendChild(t);
          setTimeout(t.remove.bind(t), 1400 + i * 45);
        }
      };
      // preços da página: com o cupom aplicado, 1 pacote e o kit já mostram o valor com o desconto no pedido
      var precosP = function(anima){
        cafesP.forEach(function(card){
          var preco = +card.dataset.preco;
          [1, 4].forEach(function(q){
            var cheio = preco * (q === 4 ? 3 : 1), fim = Math.round(cheio * (1 - pct / 100));
            var el = card.querySelector('[data-parc-preco="' + q + '"]');
            el.textContent = dinheiro(fim);
            if(anima && !REDUZ){ el.classList.remove('parc-baixou'); void el.offsetWidth; el.classList.add('parc-baixou'); }
            var de = card.querySelector('[data-parc-de="' + q + '"]');
            if(q === 1){ de.hidden = !pct; de.textContent = pct ? dinheiro(preco) : ''; }
          });
        });
      };
      var mostrarAplicado = function(parc, anima){
        pct = parc.desconto;
        $p('[data-parc-aplicar]').hidden = true;
        var ok = $p('[data-parc-aplicado]'); ok.hidden = false;
        ok.querySelector('span').textContent = 'Cupom ' + parc.codigo + ' aplicado no seu carrinho';
        precosP(anima);
      };
      cafesP.forEach(function(card){
        card.addEventListener('click', function(e){
          var b = e.target.closest('[data-parc-comprar]'); if(!b){ return; }
          var moido = card.querySelector('input[value="moido"]:checked');
          var id = +(moido ? card.dataset.moido : card.dataset.grao);
          var item = {id: id, quantity: +b.dataset.parcComprar};
          // protótipo: o carrinho simulado precisa de nome, foto e preço da variante (data-meta)
          if(card.dataset.meta){ try { item.meta = JSON.parse(card.dataset.meta)[moido ? 'moido' : 'grao']; } catch(e){} }
          comprar([item], b.querySelector('.parc-add'));
          // comprou sem clicar no botão: o cupom já estava no carrinho, a página passa a mostrar o preço com ele
          if(parcAtual && cupomNoCarrinho && !pct){ mostrarAplicado(parcAtual, false); }
        });
      });
      if(apelidoP){
        API.parceiro(apelidoP)
          .then(function(r){
            if(!r || !r.ok){ return; }
            var parc = r.parceiro, ds = paginaP.dataset;
            // veio pelo link: a indicação e o cupom valem 30 dias a partir de agora
            guardar('tml_parceiro', parc.apelido);
            guardar('tml_cupom', parc.codigo);
            guardar('tml_cupom_pct', String(parc.desconto));
            try { sessionStorage.removeItem('tml_parc_marcado'); } catch(e){}
            paginaP.classList.add('com-parceiro');
            $p('[data-parc-eyebrow]').textContent = trocaNome(ds.tEyebrow, parc);
            $p('[data-parc-titulo]').textContent = trocaNome(ds.tTitulo, parc);
            $p('[data-parc-texto]').textContent = trocaNome(ds.tTexto, parc);
            if(parc.frase){ var f = $p('[data-parc-frase]'); f.textContent = '“' + parc.frase + '”'; f.hidden = false; }
            if(parc.foto){ var ft = $p('[data-parc-foto]'); var img = new Image(); img.src = parc.foto; img.alt = parc.nome; img.width = 160; img.height = 160; ft.appendChild(img); ft.hidden = false; }
            $p('[data-parc-cupom-titulo]').textContent = 'Cupom de ' + parc.nome + ': ' + parc.codigo;
            $p('[data-parc-cupom-detalhe]').textContent = trocaNome(ds.tCupom, parc);
            var btnA = $p('[data-parc-aplicar]');
            btnA.textContent = 'Aplicar o cupom de ' + parc.nome;
            $p('[data-parc-cupom]').hidden = false;
            // cupom vai sozinho para o carrinho (com cupom de outra origem, não); o botão fica para o cliente
            parcAtual = parc;
            marcarCarrinho(parc.apelido, parc.codigo).then(function(comCupom){ cupomNoCarrinho = Boolean(comCupom); });
            btnA.addEventListener('click', function(){
              btnA.disabled = true; cupomVoa(btnA, parc.desconto); graoGirando(btnA, 'Aplicando…');
              var t0 = Date.now();
              API.aplicarCupom(parc.codigo, parc.apelido)
                .then(function(){
                  cupomNoCarrinho = true;
                  // espera as etiquetas subirem para os preços caírem
                  setTimeout(function(){ mostrarAplicado(parc, true); if(gaveta && gaveta.open){ API.carrinho().then(redesenha); } }, REDUZ ? 0 : Math.max(0, 550 - (Date.now() - t0)));
                })
                .catch(function(){ btnA.disabled = false; btnA.textContent = 'Não foi possível aplicar. Tente de novo'; });
            });
          }).catch(function(){});
      }
    }
  } catch(erro){ falhou('parceiro', erro); }

  // ===== convite discreto para o WhatsApp na página do café: depois de um tempo lendo (e rolando) a
  // página, uma linha acima do botão do WhatsApp, que abre a conversa com o código deste navegador (o CRM
  // sabe o que a pessoa viu). Uma vez por sessão; fechado, volta só em 7 dias; espera se houver outra
  // janela aberta (convite de primeira compra, carrinho). ?dica=agora mostra em 1 segundo, para testar.
  try {
    (function(){
      var fixo = document.querySelector('.whats-fixo');
      if(!fixo || !document.querySelector('[data-buybox]')){ return; }
      var agora = /[?&]dica=agora/.test(location.search);
      var guardar = function(k, v){ try { localStorage.setItem(k, v); } catch(e){} };
      var ler = function(k){ try { return localStorage.getItem(k); } catch(e){ return null; } };
      if(!agora){
        try { if(sessionStorage.getItem('tml_dica_vista')){ return; } } catch(e){}
        if(Number(ler('tml_dica_fechada') || 0) > Date.now()){ return; }
      }
      var rolou = agora;
      window.addEventListener('scroll', function(){ if(window.scrollY > 500){ rolou = true; } }, {passive: true});
      var mostrar = function(){
        if(!rolou || document.querySelector('dialog[open]')){ setTimeout(mostrar, 8000); return; }
        try { sessionStorage.setItem('tml_dica_vista', '1'); } catch(e){}
        var d = document.createElement('div');
        d.className = 'whats-dica';
        d.setAttribute('role', 'status');
        var a = document.createElement('a');
        a.href = String(fixo.getAttribute('href') || '').split('?')[0] + '?text=' + encodeURIComponent('Olá! Estou no site da Temalli e tenho uma dúvida sobre o café.');
        a.target = '_blank';
        a.rel = 'noopener';
        a.innerHTML = '<b>Dúvida sobre moagem ou método?</b>A gente responde no WhatsApp.';
        var x = document.createElement('button');
        x.type = 'button';
        x.setAttribute('aria-label', 'Fechar');
        x.textContent = '×';
        d.appendChild(a); d.appendChild(x);
        // junto do botão (no tema ele está dentro do .tml, que traz as cores e o estilo)
        (fixo.parentNode || document.body).appendChild(d);
        requestAnimationFrame(function(){ requestAnimationFrame(function(){ d.classList.add('on'); }); });
        x.addEventListener('click', function(){ guardar('tml_dica_fechada', String(Date.now() + 7 * 86400000)); d.remove(); });
        a.addEventListener('click', function(){ setTimeout(function(){ d.remove(); }, 300); });
      };
      setTimeout(mostrar, (agora ? 1 : 40) * 1000);
    })();
  } catch(erro){ falhou('dica do WhatsApp', erro); }

  // ===== convite de primeira compra (Temalli CRM): nome e WhatsApp em troca de um cupom só da pessoa, que
  // aparece aplicado no carrinho e chega no WhatsApp. Abre depois de alguns segundos (tela Primeira compra do
  // CRM) ou na saída da página, uma vez; fechado, volta só em 14 dias. Fica de fora quem já comprou (tema),
  // quem já pediu, quem chegou por um parceiro (já tem o cupom dele), o carrinho, a página do parceiro e a
  // assinatura. ?convite=agora abre em 1 segundo, para testar.
  try {
    (function(){
      var ls = function(k, v){ try { if(v === undefined){ return localStorage.getItem(k); } localStorage.setItem(k, v); } catch(e){ return null; } };
      var forcar = /[?&]convite=agora/.test(location.search);
      // cupom já ganho: a página do café volta a mostrar os preços com ele (e ele volta ao carrinho, se o
      // carrinho estiver sem cupom), até vencer
      // chegou pelo link do cupom (WhatsApp, talvez outro aparelho): o site passa a saber do cupom
      // Sem o ?cupom= (alguns links perdem o parâmetro no redirecionamento da loja), vale o cookie
      // discount_code que a própria Shopify grava ao abrir /discount/CUPOM
      var doCookie = (document.cookie.match(/(?:^|; )discount_code=([^;]+)/) || [])[1] || '';
      try { doCookie = decodeURIComponent(doCookie); } catch(e){ doCookie = ''; }
      var doLink = (new URLSearchParams(location.search).get('cupom') || doCookie).toUpperCase();
      if(/^BEMVINDO-[A-Z0-9]{5}$/.test(doLink) && ls('tml_pc_cupom') !== doLink){ ls('tml_pc_cupom', doLink); ls('tml_pc_pct', ''); ls('tml_pc_ate', ''); }
      var meu = ls('tml_pc_cupom'), meuPct = Number(ls('tml_pc_pct') || 0), meuAte = Number(ls('tml_pc_ate') || 0);
      if(meu && meu !== 'cliente' && (!meuAte || meuAte > Date.now())){
        API.carrinho().then(function(c){
          var codigos = (c.discount_codes || []).map(function(x){ return String(x.code).toUpperCase(); });
          if(codigos.indexOf(meu) > -1){ return true; }
          if(!codigos.length && meuAte && meuPct > 0){ return API.cupomPrimeiraCompra(meu, meuPct).then(function(){ return true; }); }
          return false;
        }).then(function(tem){
          if(!tem || !window.TML_CUPOM_NA_CAIXA || !document.querySelector('[data-buybox]')){ return; }
          // sem o percentual guardado (cupom de antes desta versão): o do convite
          return (meuPct > 0 ? Promise.resolve(meuPct) : API.convite().then(function(cv){ return cv && Number(cv.desconto); })).then(function(pct){
            if(pct > 0){ window.TML_CUPOM_NA_CAIXA(meu, pct); }
          });
        }).catch(function(){});
      }
      if(!forcar && (window.TML_JA_COMPROU || ls('tml_pc_cupom') || Number(ls('tml_pc_fechado') || 0) > Date.now())){ return; }
      if(/(?:^|; )tml_cupom=/.test(document.cookie) || document.querySelector('[data-parceiro], [data-carrinho-pagina], .ass-hero')){ return; }
      if(typeof HTMLDialogElement !== 'function'){ return; }
      API.convite().then(function(cv){
        if(!cv || !cv.ativo){ return; }
        var d = document.createElement('dialog');
        d.className = 'pc-dialogo tml';
        // Campanha no ar (a faixa dela está visível): o lado da oferta vira o da campanha, com o grão caindo
        // na xícara e a oferta inteira (Pague 3, Leve 4 + o cupom + frete grátis); o formulário é o mesmo
        var faixaCampanha = document.querySelector('.topbar-campanha:not([hidden])');
        var pct = Number(cv.desconto) || 0, dias = Number(cv.dias) || 0;
        var campanha = Boolean(faixaCampanha && pct > 0);
        if(campanha){ d.className += ' pc-campanha'; }
        d.setAttribute('aria-labelledby', 'pc-titulo');
        var icone = function(caminho){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + caminho + '</svg>'; };
        var lado = campanha
          ? '<div class="pc-anim" aria-hidden="true"><svg viewBox="0 0 160 120" fill="none">' +
              '<path class="pc-vapor" d="M68 40c-7-8 7-13 0-22"/><path class="pc-vapor pc-v2" d="M92 40c-7-8 7-13 0-22"/>' +
              '<g class="pc-grao"><ellipse cx="80" cy="12" rx="7" ry="10" transform="rotate(-24 80 12)"/><path d="M83 4c-5 6 1 11-3 17"/></g>' +
              '<path class="pc-xicara" d="M44 54h72v18c0 18-14 30-32 30h-8c-18 0-32-12-32-30z"/>' +
              '<path class="pc-asa" d="M116 60h6c7 0 11 5 11 11s-4 11-11 11h-8"/>' +
              '<ellipse class="pc-cafe" cx="80" cy="55" rx="34" ry="5"/><ellipse class="pc-onda" cx="80" cy="55" rx="9" ry="2"/>' +
              '<path class="pc-pires" d="M26 108h108"/>' +
            '</svg></div>' +
            '<p class="campanha-nome">' + esc((faixaCampanha.querySelector('b') || faixaCampanha).textContent.trim()) + '</p>' +
            '<p class="pc-oferta"><span class="pc-linha">Pague 3, Leve 4</span>' +
              '<span class="pc-linha">+ ' + pct + '% na primeira compra</span>' +
              '<span class="pc-linha" data-frete-topo>+ frete grátis<span data-frete-ast></span></span></p>'
          : '<span class="eyebrow">Primeira compra</span>' +
            (pct > 0 ? '<p class="pc-grande"><b>' + pct + '%</b><span>na sua primeira compra</span></p>' : '<p class="pc-grande"><span>' + esc(cv.titulo) + '</span></p>') +
            '<p class="pc-lado-nota">Soma com o Pague 3, Leve 4.</p>';
        // o lado já diz a oferta; o título do formulário diz o que fazer
        var titulo = pct > 0 ? 'Receba o seu cupom no WhatsApp' : esc(cv.titulo);
        d.innerHTML =
          '<form class="pc-caixa" novalidate>' +
            '<button type="button" class="av-fechar pc-fechar" data-pc-fechar aria-label="Fechar">×</button>' +
            '<div class="pc-lado">' + lado + '</div>' +
            '<div class="pc-corpo">' +
            '<div data-pc-pedir>' +
              '<h2 id="pc-titulo">' + titulo + '</h2>' +
              '<ul class="pc-beneficios">' +
                '<li>' + icone('<circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2.5 3.5h3l2.4 11.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.2l1.6-6.8H6.4"/>') + '<span><b>Já entra no carrinho:</b> o cupom aparece aplicado na hora.</span></li>' +
                '<li>' + icone('<path d="M20.5 11.6a8.5 8.5 0 0 1-12.4 7.5L3.5 20.5l1.4-4.5a8.5 8.5 0 1 1 15.6-4.4z"/>') + '<span><b>Chega no seu WhatsApp</b>, para usar quando quiser.</span></li>' +
                '<li>' + icone('<path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0l-7.2-7.2V3.5h9.9l7.3 7.1a2 2 0 0 1 0 2.8z"/><circle cx="8" cy="8" r="1.3"/>') + '<span><b>Soma com o Pague 3, Leve 4</b> em qualquer café.</span></li>' +
              '</ul>' +
              '<div class="pc-mascara" aria-hidden="true"><span>' + icone('<rect x="4.5" y="10.5" width="15" height="10" rx="2"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/>') + 'Seu cupom</span><b>BEMVINDO-•••••</b></div>' +
              '<div class="pc-campos">' +
                '<label class="m-campo"><span>Seu nome</span><input name="nome" autocomplete="given-name" maxlength="60" required></label>' +
                '<label class="m-campo"><span>WhatsApp com DDD</span><input name="whatsapp" type="tel" inputmode="tel" autocomplete="tel-national" placeholder="(11) 98765-4321" required></label>' +
              '</div>' +
              '<label class="pc-check"><input type="checkbox" name="novidades"><span>Quero receber novidades e lembretes da Temalli no WhatsApp</span></label>' +
              '<input class="pc-robo" name="site" tabindex="-1" autocomplete="off" aria-hidden="true">' +
              '<p class="pc-erro" data-pc-erro role="alert"></p>' +
              '<button class="btn btn-bloco" type="submit">' + (pct > 0 ? 'Quero meus ' + pct + '% de desconto' : 'Quero meu cupom') + '</button>' +
              '<p class="micro">Um cupom por pessoa, para a primeira compra' + (dias ? ', válido por ' + dias + ' dias' : '') + '.</p>' +
              (campanha ? '<p class="micro" data-frete-nota hidden>* O frete grátis depende do estado de entrega.</p>' : '') +
              '<button type="button" class="pc-agora-nao" data-pc-fechar>Agora não</button>' +
            '</div>' +
            '<div data-pc-pronto hidden>' +
              '<span class="eyebrow">Cupom aplicado</span>' +
              '<h2 data-pc-ola></h2>' +
              '<p class="pc-texto">O cupom já está no seu carrinho e também foi para o seu WhatsApp.</p>' +
              '<div class="pc-codigo"><b data-pc-codigo></b><small data-pc-validade></small></div>' +
              '<button class="btn btn-bloco" type="button" data-pc-fechar>Continuar escolhendo</button>' +
            '</div>' +
            '<div data-pc-cliente hidden>' +
              '<span class="eyebrow">Que bom ter você aqui</span>' +
              '<h2 data-pc-ola-cliente></h2>' +
              '<p class="pc-texto" data-pc-texto-cliente></p>' +
              '<button class="btn btn-bloco" type="button" data-pc-fechar>Continuar escolhendo</button>' +
            '</div>' +
            '</div>' +
          '</form>';
        document.body.appendChild(d);
        // a linha do frete grátis segue a regra do estado de quem visita (como a faixa do topo)
        if(d.className.indexOf('pc-campanha') > -1 && typeof pintarFrete === 'function'){ try { pintarFrete(); } catch(x){} }
        var aberto = false, pronto = false, inicio = Date.now(), timer;
        // o pixel do CRM conta quem viu, quem fechou sem preencher e quem pegou o cupom (funil da Primeira compra)
        var avisar = function(acao){
          var an = window.Shopify && window.Shopify.analytics;
          if(an && typeof an.publish === 'function'){ try { an.publish('temalli_convite', {acao: acao}); } catch(x){} }
        };
        var abrir = function(){
          if(aberto){ return; }
          // outra janela aberta (carrinho, avaliações): tenta de novo daqui a pouco
          if(document.querySelector('dialog[open]')){ clearTimeout(timer); timer = setTimeout(abrir, 5000); return; }
          aberto = true; clearTimeout(timer);
          d.showModal();
          avisar('visto');
        };
        var fechar = function(){
          if(!pronto){ ls('tml_pc_fechado', String(Date.now() + 14 * 86400000)); avisar('fechado'); }
          d.close();
        };
        timer = setTimeout(abrir, (forcar ? 1 : Math.max(3, Number(cv.atraso) || 20)) * 1000);
        // saída: o mouse sai pelo topo da janela (computador) ou a rolagem volta para cima depressa (celular)
        document.addEventListener('mouseout', function(e){ if(!e.relatedTarget && e.clientY <= 0 && Date.now() - inicio > 4000){ abrir(); } });
        var yAntes = window.scrollY, tAntes = Date.now();
        window.addEventListener('scroll', function(){
          var y = window.scrollY, t = Date.now();
          if(yAntes - y > 250 && t - tAntes < 250 && y > 600 && t - inicio > 8000){ abrir(); }
          yAntes = y; tAntes = t;
        }, {passive: true});
        d.addEventListener('click', function(e){ if(e.target.closest('[data-pc-fechar]') || e.target === d){ fechar(); } });
        d.addEventListener('cancel', function(e){ e.preventDefault(); fechar(); });
        var f = d.querySelector('form'), tel = f.querySelector('[name="whatsapp"]');
        tel.addEventListener('input', function(){
          var n = tel.value.replace(/\D/g, '').replace(/^55(?=\d{10,11}$)/, '').slice(0, 11);
          tel.value = n.length > 6 ? '(' + n.slice(0, 2) + ') ' + n.slice(2, n.length - 4) + '-' + n.slice(n.length - 4) : n.length > 2 ? '(' + n.slice(0, 2) + ') ' + n.slice(2) : n;
        });
        f.addEventListener('submit', function(e){
          e.preventDefault();
          var erro = f.querySelector('[data-pc-erro]'), btn = f.querySelector('[type="submit"]');
          var nome = f.nome.value.replace(/\s+/g, ' ').trim(), whats = f.whatsapp.value;
          erro.textContent = '';
          if(nome.length < 2){ erro.textContent = 'Digite o seu nome.'; f.nome.focus(); return; }
          if(whats.replace(/\D/g, '').length < 10){ erro.textContent = 'Confira o WhatsApp, com DDD.'; f.whatsapp.focus(); return; }
          btn.disabled = true; btn.textContent = 'Gerando o seu cupom...';
          API.pedirCupom({nome: nome, whatsapp: whats, novidades: f.novidades.checked, pagina: location.pathname, site: f.site.value})
            .then(function(r){
              // o pixel do CRM liga este navegador ao contato (o "Ao vivo" e os fluxos do site passam a
              // reconhecer a pessoa), com cupom ou sem
              var an = window.Shopify && window.Shopify.analytics;
              if(r && r.token && an && typeof an.publish === 'function'){ try { an.publish('temalli_identificado', {token: r.token}); } catch(x){} }
              var primeiro = nome.split(' ')[0];
              primeiro = primeiro.charAt(0).toUpperCase() + primeiro.slice(1).toLowerCase();
              // já é cliente (ou já teve o cupom): o CRM guardou o contato; boas-vindas no lugar do erro
              if(r && !r.ok && r.cliente){
                pronto = true;
                ls('tml_pc_cupom', 'cliente');
                d.querySelector('[data-pc-ola-cliente]').textContent = 'Olá de novo, ' + primeiro;
                d.querySelector('[data-pc-texto-cliente]').textContent = r.erro + (f.novidades.checked ? ' As novidades e os lembretes vão chegar no seu WhatsApp.' : '');
                d.querySelector('[data-pc-pedir]').hidden = true;
                d.querySelector('[data-pc-cliente]').hidden = false;
                return;
              }
              if(!r || !r.ok){ throw new Error(r && r.erro || 'Não foi possível gerar o cupom agora. Tente de novo em instantes.'); }
              pronto = true;
              avisar('cupom');
              ls('tml_pc_cupom', r.codigo);
              ls('tml_pc_pct', String(r.desconto));
              ls('tml_pc_ate', String(Date.parse(r.expiraEm) || Date.now() + 7 * 86400000));
              d.querySelector('[data-pc-codigo]').textContent = r.codigo;
              d.querySelector('[data-pc-validade]').textContent = 'Válido até ' + r.validade + '. Soma com o Pague 3, Leve 4.';
              d.querySelector('[data-pc-pedir]').hidden = true;
              d.querySelector('[data-pc-pronto]').hidden = false;
              d.querySelector('.pc-codigo').classList.add('pc-ganhou');
              // o momento do ganho: etiquetas −10% e −R$ saem do código do cupom (como na página do parceiro),
              // dentro do convite, que fica acima da página
              if(!window.matchMedia || !matchMedia('(prefers-reduced-motion: reduce)').matches){
                var voo = d.querySelector('.pc-voo');
                if(!voo){ voo = document.createElement('div'); voo.className = 'pc-voo'; d.appendChild(voo); }
                var rd = d.getBoundingClientRect(), rb = d.querySelector('.pc-codigo').getBoundingClientRect();
                var cx = rb.left - rd.left + rb.width / 2, cy = rb.top - rd.top + rb.height / 2;
                for(var i = 0; i < 8; i++){
                  var t = document.createElement('span'), ang = -Math.PI / 2 + (i - 3.5) * 0.32 + (Math.random() - 0.5) * 0.2, dist = 90 + Math.random() * 60;
                  t.className = 'cupom-voa';
                  t.textContent = i % 2 ? '−' + r.desconto + '%' : '−R$';
                  t.style.left = cx + (Math.random() - 0.5) * rb.width * 0.6 + 'px'; t.style.top = cy + 'px';
                  t.style.setProperty('--dx', Math.round(Math.cos(ang) * dist) + 'px');
                  t.style.setProperty('--dy', Math.round(Math.sin(ang) * dist) + 'px');
                  t.style.setProperty('--r', Math.round(Math.random() * 30 - 15) + 'deg');
                  t.style.animationDelay = (i * 45) + 'ms';
                  voo.appendChild(t);
                  setTimeout(t.remove.bind(t), 1400 + i * 45);
                }
              }
              d.querySelector('[data-pc-ola]').textContent = 'Pronto, ' + primeiro + '. São ' + r.desconto + '% na sua primeira compra';
              return API.cupomPrimeiraCompra(r.codigo, r.desconto).then(function(){
                // página do café: os preços passam a mostrar o valor com o cupom
                if(window.TML_CUPOM_NA_CAIXA && document.querySelector('[data-buybox]')){ window.TML_CUPOM_NA_CAIXA(r.codigo, r.desconto); }
              }).catch(function(){});
            })
            .catch(function(x){ erro.textContent = x.message; btn.disabled = false; btn.textContent = 'Quero meu cupom'; });
        });
      }).catch(function(){});
    })();
  } catch(erro){ falhou('primeira compra', erro); }

  // serra em paralaxe: as linhas deslizam com a rolagem (celular) e com o mouse (computador)
  try {
    if(!REDUZ){
      var serras = document.querySelectorAll('.hero-home, .lp-hero');
      if(serras.length){
        var mouseX = 0, pendente = false;
        var aplicaSerra = function(){
          pendente = false;
          var x = -window.scrollY * 0.6 + mouseX;
          serras.forEach(function(s){ s.style.setProperty('--serra-x', x.toFixed(1) + 'px'); });
        };
        var agendaSerra = function(){ if(!pendente){ pendente = true; requestAnimationFrame(aplicaSerra); } };
        window.addEventListener('scroll', agendaSerra, {passive: true});
        if(window.matchMedia('(hover: hover)').matches){
          window.addEventListener('mousemove', function(e){ mouseX = (e.clientX / window.innerWidth - 0.5) * -90; agendaSerra(); }, {passive: true});
        }
        aplicaSerra();
      }
    }
  } catch(erro){ falhou('serra', erro); }

  // pirâmide da qualidade: tocar/passar o mouse em um nível mostra a explicação
  try {
    document.querySelectorAll('[data-piramide]').forEach(function(p){
      var niveis = Array.prototype.slice.call(p.querySelectorAll('.pir-nivel'));
      var nome = p.querySelector('[data-pir-nome]'), crit = p.querySelector('[data-pir-criterio]'), desc = p.querySelector('[data-pir-desc]');
      var pir = p.querySelector('.piramide'), info = p.querySelector('.pir-info'), ponte = p.querySelector('.pir-ponte'), atual = null;
      function preenche(b){ nome.textContent = b.dataset.nome; crit.textContent = b.dataset.criterio; desc.textContent = b.dataset.desc; }
      // conector tracejado do (i) da faixa ativa até o painel (só com as duas colunas lado a lado)
      function liga(){
        if(!ponte || !atual) return;
        var ic = atual.querySelector('.pir-i');
        if(!ic || window.matchMedia('(max-width:860px)').matches){ ponte.classList.remove('vis'); return; }
        var g = p.getBoundingClientRect(), r = ic.getBoundingClientRect(), pr = info.getBoundingClientRect();
        var x = r.right - g.left + 6;
        ponte.style.top = (r.top + r.height / 2 - g.top) + 'px';
        ponte.style.left = x + 'px';
        ponte.style.width = Math.max(0, pr.left - g.left - x) + 'px';
        ponte.classList.add('vis');
      }
      // o painel fica com a altura da maior explicação: trocar de faixa não empurra a página (sem "piscar")
      function fixaAltura(){
        info.style.minHeight = '';
        var max = 0;
        niveis.forEach(function(b){ preenche(b); max = Math.max(max, info.offsetHeight); });
        if(atual){ preenche(atual); }
        info.style.minHeight = max + 'px';
      }
      function ativa(b){
        if(b === atual) return;
        atual = b;
        niveis.forEach(function(x){ x.classList.toggle('ativo', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        preenche(b);
        liga();
      }
      niveis.forEach(function(b){
        b.addEventListener('click', function(){ ativa(b); });
        if(window.matchMedia('(hover: hover)').matches){ b.addEventListener('mouseenter', function(){ ativa(b); }); }
      });
      if(niveis.length){
        ativa(niveis[0]); fixaAltura();
        if(document.fonts && document.fonts.ready){ document.fonts.ready.then(function(){ fixaAltura(); liga(); }); }
        var tm; window.addEventListener('resize', function(){ clearTimeout(tm); tm = setTimeout(function(){ fixaAltura(); liga(); }, 150); });
        // depois que a pirâmide termina de se montar, liga o conector e tira os atrasos da animação de entrada
        var monta = function(){ setTimeout(function(){ pir.classList.add('montada'); liga(); }, 1400); };
        if(pir.classList.contains('on') || !pir.classList.contains('reveal')){ monta(); }
        else { new MutationObserver(function(m, o){ if(pir.classList.contains('on')){ o.disconnect(); monta(); } }).observe(pir, {attributes:true, attributeFilter:['class']}); }
      }
    });
  } catch(erro){ falhou('pirâmide', erro); }

  // rodapé: momento do dia do céu e, se a seção logo acima for escura, transição sem a bruma clara
  try {
    (function(){
      var rod = document.querySelector('footer.site'); if(!rod) return;
      // céu pela hora de quem visita: dia (creme) 6h–18h, noite no resto (?ceu=dia|noite para testar)
      var h = new Date().getHours(), forcado = (location.search.match(/[?&]ceu=(dia|noite)/) || [])[1];
      if((forcado || (h >= 6 && h < 18 ? 'dia' : 'noite')) === 'dia'){ rod.classList.add('ceu-dia'); }
      // cor do que encosta no rodapé: desce da <main> sempre pelo filho que chega até a borda do rodapé
      // e guarda o último fundo opaco de largura total (body se nenhum). Não depende de ser <section>.
      var topo = rod.getBoundingClientRect().top, fundoAcima = getComputedStyle(document.body).backgroundColor;
      for(var el = document.querySelector('main') || document.body; el; ){
        var cs = getComputedStyle(el), m = cs.backgroundColor.match(/[\d.]+/g);
        if(m && (m.length < 4 || +m[3] > .5) && el.getBoundingClientRect().width >= window.innerWidth * .9){ fundoAcima = cs.backgroundColor; }
        var filhos = Array.prototype.filter.call(el.children, function(c){
          var r = c.getBoundingClientRect(), p = getComputedStyle(c).position;
          return r.height > 0 && r.bottom >= topo - 4 && p !== 'fixed' && p !== 'absolute';
        });
        el = filhos[filhos.length - 1];
      }
      var rgb = fundoAcima.match(/[\d.]+/g) || [255, 255, 255];
      rod.style.setProperty('--cor-acima', fundoAcima);   // o céu nasce da cor do que está logo acima
      if((.2126 * rgb[0] + .7152 * rgb[1] + .0722 * rgb[2]) / 255 < .35){ rod.classList.add('sobre-escuro'); }
    })();
  } catch(erro){ falhou('rodapé', erro); }

  // políticas (texto cadastrado na Shopify): índice "Nesta página" a partir dos títulos do texto
  try {
    document.querySelectorAll('[data-pol]').forEach(function(art){
      var corpo = art.querySelector('.shopify-policy__body') || art;
      var toc = document.querySelector('[data-pol-toc]');
      var tits = Array.prototype.slice.call(corpo.querySelectorAll('h2, h3'));
      if(tits.length < 3){
        // muitas políticas usam parágrafos só em negrito como títulos
        corpo.querySelectorAll('p').forEach(function(p){
          var txt = p.textContent.trim(), b = p.querySelector('strong, b');
          if(b && txt && b.textContent.trim() === txt && txt.length < 90){ p.classList.add('pol-titulo'); tits.push(p); }
        });
        tits.sort(function(a, b){ return a.compareDocumentPosition(b) & 4 ? -1 : 1; });
      }
      if(!toc || tits.length < 3) return;
      var lista = toc.querySelector('ol'), links = [];
      tits.forEach(function(t, i){
        if(!t.id){ t.id = 'secao-' + (i + 1) + '-' + t.textContent.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40); }
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + t.id; a.textContent = t.textContent.trim().replace(/[:.]$/, '');
        li.appendChild(a); lista.appendChild(li); links.push(a);
      });
      toc.hidden = false;
      if('IntersectionObserver' in window){
        var vis = new IntersectionObserver(function(entries){
          entries.forEach(function(en){
            if(en.isIntersecting){ links.forEach(function(a){ a.classList.toggle('ativo', a.getAttribute('href') === '#' + en.target.id); }); }
          });
        }, {rootMargin: '-110px 0px -70% 0px'});
        tits.forEach(function(t){ vis.observe(t); });
      }
    });
  } catch(erro){ falhou('políticas', erro); }

  /* ---------- WhatsApp: código do site na mensagem ----------
     Os botões de WhatsApp abrem com a mensagem pronta; no fim vai um código curto deste navegador,
     ex.: "(ref. K7M2Q)". O pixel do CRM sabe de qual navegador é o código e, quando a mensagem chega,
     o CRM liga a conversa ao que a pessoa viu no site. O mesmo código vale para todos os botões. */
  try {
    var LETRAS_REF = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
    var codigoRef = function(){
      var c = null;
      try { c = localStorage.getItem('tml_ref'); } catch(x){}
      if(!c || !/^[A-HJKMNP-Z2-9]{5}$/.test(c)){
        var r = new Uint32Array(5);
        if(window.crypto && crypto.getRandomValues){ crypto.getRandomValues(r); } else { for(var j = 0; j < 5; j++){ r[j] = Math.floor(Math.random() * 1e9); } }
        c = '';
        for(var i = 0; i < 5; i++){ c += LETRAS_REF.charAt(r[i] % LETRAS_REF.length); }
        try { localStorage.setItem('tml_ref', c); } catch(x){}
      }
      return c;
    };
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com/send"]');
      if(!a) return;
      var c = codigoRef(), partes = a.href.split('?'), achou = false;
      var pares = (partes.slice(1).join('?') || '').split('&').filter(Boolean).map(function(p){
        if(p.indexOf('text=') !== 0) return p;
        achou = true;
        var t = '';
        try { t = decodeURIComponent(p.slice(5).replace(/\+/g, ' ')); } catch(x){ return p; }
        return /\(ref\. [A-Z0-9]{5}\)/.test(t) ? p : 'text=' + encodeURIComponent(t + '\n\n(ref. ' + c + ')');
      });
      if(!achou) pares.push('text=' + encodeURIComponent('Olá! Vim pelo site da Temalli.\n\n(ref. ' + c + ')'));
      a.href = partes[0] + '?' + pares.join('&');
      var an = window.Shopify && window.Shopify.analytics;
      if(an && typeof an.publish === 'function'){ try { an.publish('temalli_whatsapp', {codigo: c}); } catch(x){} }
    }, true);
  } catch(erro){ falhou('código do WhatsApp', erro); }

})();
